import React, { Component } from 'react';
import { Form, DatePicker, Input, Button, Table, Popconfirm, Col, Row, Menu, Dropdown, Icon, Checkbox, Select, InputNumber, Switch, Slider, Radio, Rate, Upload, AutoComplete, Tooltip, Cascader, TimePicker, List, Avatar, Modal, Divider } from 'antd';
import { RegistComponent, uimap, AntInputField, ModalAction, EuModalService, CURDAction } from 'easyui-core';
import Form$1 from 'antd/lib/form';
import update from 'immutability-helper';
import { DropTarget, DragSource, DndProvider } from 'react-dnd';
import Row$1 from 'antd/lib/row';
import Col$1 from 'antd/lib/col';
import reqwest from 'reqwest';
import { combineReducers, createStore } from 'redux';
import { connect, Provider } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button$1 from 'antd/lib/button';
import List$1 from 'antd/lib/list';
import Card from 'antd/lib/card';
import HTML5Backend from 'react-dnd-html5-backend';
import ReactDOM from 'react-dom';
import AntTable$1 from 'antd/lib/table';
import Input$1 from 'antd/lib/input';
import Icon$1 from 'antd/lib/icon';
import AntTree from 'antd/lib/tree';
import Highlighter from 'react-highlight-words';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var AntDatetimePick = /** @class */ (function (_super) {
    __extends(AntDatetimePick, _super);
    function AntDatetimePick(props) {
        var _this = _super.call(this, props) || this;
        _this.handleValueChange = function (value) {
        };
        _this.field = _this.props.field;
        return _this;
    }
    AntDatetimePick.prototype.render = function () {
        var formLayout = this.props.formLayout;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null
        return (React.createElement(Form.Item, __assign({}, formItemLayout, { label: this.props.field.label }), getFieldDecorator(this.field.key, {
            rules: [{
                    validator: this.field.validator
                    // type: this.field.validator, message: 'The input is not valid E-mail!',
                }, {
                    required: this.field.required, message: '必填项!',
                }],
        })(React.createElement(DatePicker, { showTime: true, format: "YYYY-MM-DD HH:mm:ss" }))));
    };
    return AntDatetimePick;
}(React.Component));
RegistComponent({
    selector: "ef-ant-datepicker",
    component: AntDatetimePick,
    name: "Ant日期时间选择"
});
// export default AntInput

var AntInput = /** @class */ (function (_super) {
    __extends(AntInput, _super);
    function AntInput(props) {
        var _this = _super.call(this, props) || this;
        _this.handleValueChange = function (value) {
            debugger;
        };
        _this.field = _this.props.field;
        return _this;
    }
    AntInput.prototype.render = function () {
        var formLayout = this.props.formLayout;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null
        return (React.createElement(Form.Item, __assign({}, formItemLayout, { label: this.props.field.label }), getFieldDecorator(this.field.key, {
            rules: [{
                    validator: this.field.validator
                    // type: this.field.validator, message: 'The input is not valid E-mail!',
                }, {
                    required: this.field.required, message: '必填项!',
                }],
        })(React.createElement(Input, { disabled: this.field.disabled, onChange: this.handleValueChange }))));
    };
    return AntInput;
}(React.Component));
RegistComponent({
    selector: "ef-ant-input",
    component: AntInput,
    name: "Ant输入框"
});
// export default AntInput

var TextArea = Input.TextArea;
var AntTextarea = /** @class */ (function (_super) {
    __extends(AntTextarea, _super);
    function AntTextarea(props) {
        var _this = _super.call(this, props) || this;
        _this.field = _this.props.field;
        return _this;
    }
    AntTextarea.prototype.render = function () {
        var formLayout = this.props.formLayout;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null
        return (React.createElement(Form.Item, __assign({}, formItemLayout, { label: this.props.field.label }), getFieldDecorator(this.field.key, {
            rules: [{
                // type: this.field.validator, message: 'The input is not valid E-mail!',
                }, {
                    required: this.field.required, message: '必填项!',
                }],
        })(React.createElement(TextArea, { rows: 4 }))));
    };
    return AntTextarea;
}(React.Component));
RegistComponent({
    selector: "ef-ant-textarea",
    component: AntTextarea,
    name: "Ant文本域"
});
// export default AntTextarea

var FormItem = Form.Item;
var EditableContext = React.createContext({});
var EditableRow = function (_a) {
    var form = _a.form, index = _a.index, props = __rest(_a, ["form", "index"]);
    return (React.createElement(EditableContext.Provider, { value: form },
        React.createElement("tr", __assign({}, props))));
};
var EditableFormRow = Form.create()(EditableRow);
var EditableCell = /** @class */ (function (_super) {
    __extends(EditableCell, _super);
    function EditableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editing: false,
        };
        _this.toggleEdit = function () {
            var editing = !_this.state.editing;
            _this.setState({ editing: editing }, function () {
                if (editing) {
                    _this.input.focus();
                }
            });
        };
        _this.save = function (e) {
            var _a = _this.props, record = _a.record, handleSave = _a.handleSave;
            _this.form.validateFields(function (error, values) {
                if (error && error[e.currentTarget.id]) {
                    return;
                }
                _this.toggleEdit();
                handleSave(__assign({}, record, values));
            });
        };
        return _this;
    }
    EditableCell.prototype.render = function () {
        var _this = this;
        var editing = this.state.editing;
        var _a = this.props, editable = _a.editable, dataIndex = _a.dataIndex, title = _a.title, record = _a.record, index = _a.index, handleSave = _a.handleSave, restProps = __rest(_a, ["editable", "dataIndex", "title", "record", "index", "handleSave"]);
        return (React.createElement("td", __assign({}, restProps), editable ? (React.createElement(EditableContext.Consumer, null, function (form) {
            _this.form = form;
            return (editing ? (React.createElement(FormItem, { style: { margin: 0 } }, form.getFieldDecorator(dataIndex, {
                rules: [{
                        required: true,
                        message: title + " is required.",
                    }],
                initialValue: record[dataIndex],
            })(React.createElement(Input, { ref: function (node) { return (_this.input = node); }, onPressEnter: _this.save, onBlur: _this.save })))) : (React.createElement("div", { className: "editable-cell-value-wrap", style: { paddingRight: 24 }, onClick: _this.toggleEdit }, restProps.children)));
        })) : restProps.children));
    };
    return EditableCell;
}(React.Component));
var AntEditTable = /** @class */ (function (_super) {
    __extends(AntEditTable, _super);
    function AntEditTable(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTableChange = function (pagination, filters, sorter) {
            // const pager = { ...this.state.pagination };
            // pager.current = pagination.current;
            // this.setState({
            //     pagination: pager,
            // });
            // this.fetch({
            //     results: pagination.pageSize,
            //     page: pagination.current,
            //     sortField: sorter.field,
            //     sortOrder: sorter.order,
            //     ...filters,
            // });
        };
        _this.handleDelete = function (key) {
            var data = _this.state.data.slice();
            var newDatas = data.filter(function (item) { return item.key !== key; });
            _this.setState({ data: newDatas });
            var onChange = _this.props.onChange;
            if (onChange) {
                // onChange(Object.assign({}, this.state.data, []));
                onChange(Object.assign([], newDatas, []));
            }
        };
        _this.handleAdd = function () {
            var _a = _this.state, total = _a.total, data = _a.data;
            var newData = {
                key: total,
                name: "Edward King " + total,
                age: 32,
                address: "London, Park Lane no. " + total,
            };
            var newdatas = data.concat([newData]);
            _this.setState({
                data: newdatas,
                total: total + 1,
            });
            var onChange = _this.props.onChange;
            if (onChange) {
                // onChange(Object.assign({}, this.state.data, []));
                onChange(Object.assign([], newdatas, []));
            }
        };
        _this.handleSave = function (row) {
            var newData = _this.state.data.slice();
            var index = newData.findIndex(function (item) { return row.key === item.key; });
            var item = newData[index];
            newData.splice(index, 1, __assign({}, item, row));
            _this.setState({
                data: newData
            });
            var onChange = _this.props.onChange;
            if (onChange) {
                // onChange(Object.assign({}, this.state.data, []));
                onChange(Object.assign([], newData, []));
            }
        };
        _this.columns = [{
                title: 'name',
                dataIndex: 'name',
                width: '30%',
                editable: true,
            }, {
                title: 'age',
                dataIndex: 'age',
                editable: true
            }, {
                title: 'address',
                dataIndex: 'address',
                editable: true
            }, {
                title: 'operation',
                dataIndex: 'operation',
                render: function (text, record) { return (_this.state.data.length >= 1
                    ? (React.createElement(Popconfirm, { title: "Sure to delete?", onConfirm: function () { return _this.handleDelete(record.key); } },
                        React.createElement("a", { href: "javascript:;" }, "Delete"))) : null); },
            }];
        _this.state = {
            data: [{
                    key: '0',
                    name: 'Edward King 0',
                    age: '32',
                    address: 'London, Park Lane no. 0',
                }, {
                    key: '1',
                    name: 'Edward King 1',
                    age: '32',
                    address: 'London, Park Lane no. 1',
                }],
            total: 2,
        };
        return _this;
    }
    AntEditTable.getDerivedStateFromProps = function (nextProps) {
        // Should be a controlled component.
        if ('value' in nextProps) {
            var datas = (nextProps.value || []).slice();
            return {
                data: datas
            };
        }
        return null;
    };
    AntEditTable.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        var components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell,
            },
        };
        var columns = this.columns.map(function (col) {
            if (!col.editable) {
                return col;
            }
            return __assign({}, col, { onCell: function (record) { return ({
                    record: record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: _this.handleSave,
                }); } });
        });
        return (React.createElement("div", null,
            React.createElement(Button, { onClick: this.handleAdd, type: "primary", style: { marginBottom: 16 } }, "Add a row"),
            React.createElement(Table, { components: components, rowClassName: function () { return 'editable-row'; }, bordered: true, dataSource: data, columns: columns, onChange: this.handleTableChange })));
    };
    return AntEditTable;
}(React.Component));
var AntEditTableForm = /** @class */ (function (_super) {
    __extends(AntEditTableForm, _super);
    function AntEditTableForm(props) {
        var _this = _super.call(this, props) || this;
        _this.field = _this.props.field;
        _this.state = {
            data: []
        };
        return _this;
    }
    AntEditTableForm.prototype.render = function () {
        var formLayout = this.props.formLayout;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        return (React.createElement(Form.Item, __assign({}, formItemLayout, { label: this.props.field.label }), getFieldDecorator(this.field.key, {
            rules: [
            // {
            // validator: this.field.validator,
            // type: this.field.validator, message: 'The input is not valid E-mail!',
            // type: 'array'
            // },
            // {
            //     required: this.field.required, message: '必填项!',
            //     type: 'array'
            // }
            ],
        })(React.createElement(AntEditTable, null))));
    };
    return AntEditTableForm;
}(React.Component));
RegistComponent({
    selector: "ef-ant-edit-table",
    component: AntEditTableForm,
    name: "Ant表格控件"
});

var AntWfComponent = /** @class */ (function (_super) {
    __extends(AntWfComponent, _super);
    function AntWfComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // constructor(props) {
        //     super(props);
        // }
        _this.components = {};
        return _this;
    }
    AntWfComponent.prototype.render = function () {
        // const TagName = this.components[this.props.tag || 'AntInput'];
        var TagName = this.props.component;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement(Col, { span: this.props.field.span },
            React.createElement(TagName, { form: this.props.form, field: this.props.field, formLayout: this.props.formLayout })));
    };
    return AntWfComponent;
}(Component));

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".AntWfForm_ant-form-item__3Jl5j{\n    margin-bottom: 12px;\n}";
styleInject(css);

var columns = [{
        title: 'Name',
        dataIndex: 'name',
        sorter: true,
        render: function (name) { return name.first + " " + name.last; },
        width: '20%',
    }, {
        title: 'Gender',
        dataIndex: 'gender',
        filters: [
            { text: 'Male', value: 'male' },
            { text: 'Female', value: 'female' },
        ],
        width: '20%',
    }, {
        title: 'Email',
        dataIndex: 'email',
    }];
var AntTableDemo = /** @class */ (function (_super) {
    __extends(AntTableDemo, _super);
    function AntTableDemo(props) {
        var _this = _super.call(this, props) || this;
        _this.triggerChange = function (changedValue) {
            // Should provide an event to pass value to Form.
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(Object.assign({}, _this.state, changedValue));
            }
        };
        _this.handleTableChange = function (pagination, filters, sorter) {
            var pager = __assign({}, _this.state.pagination);
            pager.current = pagination.current;
            _this.setState({
                pagination: pager,
            });
            _this.fetch(__assign({ results: pagination.pageSize, page: pagination.current, sortField: sorter.field, sortOrder: sorter.order }, filters));
        };
        _this.fetch = function (params) {
            if (params === void 0) { params = {}; }
            console.log('params:', params);
            // this.setState({ loading: true });
            // reqwest({
            //     url: 'https://randomuser.me/api',
            //     method: 'get',
            //     data: {
            //         results: 10,
            //         ...params,
            //     },
            //     type: 'json',
            // }).then((data) => {
            //     const pagination = { ...this.state.pagination };
            //     // Read total count from server
            //     // pagination.total = data.totalCount;
            //     pagination.total = 200;
            //     this.setState({
            //         loading: false,
            //         data: data.results,
            //         pagination,
            //     });
            //     const onChange = this.props.onChange;
            //     if (onChange) {
            //         // onChange(Object.assign({}, this.state.data, []));
            //         onChange(Object.assign([], data.results, []));
            //     }
            // });
        };
        var value = props.value || [];
        _this.state = {
            data: value,
            pagination: {
                current: 0,
                total: 0
            },
            loading: false,
        };
        return _this;
    }
    AntTableDemo.getDerivedStateFromProps = function (nextProps) {
        // Should be a controlled component.
        if ('value' in nextProps) {
            var datas = (nextProps.value || []).slice();
            return {
                data: datas
            };
        }
        return null;
    };
    AntTableDemo.prototype.componentDidMount = function () {
        this.fetch();
    };
    AntTableDemo.prototype.render = function () {
        return (React.createElement(Table, { columns: columns, rowKey: function (record) { return record.login.uuid; }, dataSource: this.state.data, pagination: this.state.pagination, loading: this.state.loading, onChange: this.handleTableChange }));
    };
    return AntTableDemo;
}(React.Component));
var AntTableForm = /** @class */ (function (_super) {
    __extends(AntTableForm, _super);
    function AntTableForm(props) {
        var _this = _super.call(this, props) || this;
        _this.field = _this.props.field;
        _this.state = {
            data: []
        };
        return _this;
    }
    AntTableForm.prototype.render = function () {
        var formLayout = this.props.formLayout;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        return (React.createElement(Form.Item, __assign({}, formItemLayout, { label: this.props.field.label }), getFieldDecorator(this.field.key, {
            rules: [
            // {
            // validator: this.field.validator,
            // type: this.field.validator, message: 'The input is not valid E-mail!',
            // type: 'array'
            // },
            // {
            //     required: this.field.required, message: '必填项!',
            //     type: 'array'
            // }
            ],
        })(React.createElement(AntTableDemo, null))));
    };
    return AntTableForm;
}(React.Component));
RegistComponent({
    selector: "ef-ant-table",
    component: AntTableForm,
    name: "Ant表格控件"
});

var AntWfForm = /** @class */ (function (_super) {
    __extends(AntWfForm, _super);
    function AntWfForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (!err) {
                    console.log('Received values of form: ', values);
                }
            });
        };
        _this.uimap = uimap;
        _this.state = {
            formLayout: "vertical"
        };
        return _this;
    }
    AntWfForm.prototype.render = function () {
        var _this = this;
        var formItems = this.props.fields.map(function (field, index) { return (React.createElement(AntWfComponent, { component: _this.uimap.get(field.selector), key: field.key, form: _this.props.form, field: field, formLayout: _this.state.formLayout })); });
        return (React.createElement(Form$1, { onSubmit: this.handleSubmit, layout: this.state.formLayout, className: "login-form" },
            React.createElement(Row, { gutter: 16 }, formItems)));
    };
    return AntWfForm;
}(Component));
var WrappedAntWfForm = Form$1.create({ name: 'antWfForm' })(AntWfForm);

var style = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
};
var WfComponentTarget = {
    drop: function (props, monitor) {
        var item = monitor.getItem();
        console.log("item", item);
        if (item && item.index != undefined) {
            var dragIndex = item.index;
            var hoverIndex = props.index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Time to actually perform the action
            props.moveField(dragIndex, hoverIndex);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            monitor.getItem().index = hoverIndex;
        }
        else {
            var hoverIndex = props.index;
            props.addField(item, hoverIndex);
        }
    },
};
var WfComponentDropConnect = function (connect, monitor, props) { return ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}); };
var WfComponentSource = {
    beginDrag: function (props) {
        // Return the data describing the dragged item
        var item = {
            id: props.key,
            index: props.index,
            field: props.field
        };
        return item;
    },
    endDrag: function (props, monitor, component) {
        // debugger
        if (!monitor.didDrop()) {
            return;
        }
        // When dropped on a compatible target, do something
        var item = monitor.getItem();
        var dropResult = monitor.getDropResult();
        //   CardActions.moveCardToList(item.id, dropResult.listId)
    },
};
/**
 * Specifies which props to inject into your component.
 */
function collect(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging(),
    };
}
var AntWfDragComponent = /** @class */ (function (_super) {
    __extends(AntWfDragComponent, _super);
    function AntWfDragComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.components = {};
        _this.myRef = React.createRef();
        console.log("=======", props);
        return _this;
    }
    AntWfDragComponent.prototype.render = function () {
        var _a = this.props, isDragging = _a.isDragging, connectDragSource = _a.connectDragSource, connectDropTarget = _a.connectDropTarget;
        var TagName = this.props.component;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var opacity = isDragging ? 0 : 1;
        // const containerStyle = useMemo(() => ({ ...style, opacity }), [opacity])
        var containerStyle = __assign({}, style, { opacity: opacity });
        return connectDropTarget(connectDragSource(React.createElement("div", null,
            React.createElement(Col, { ref: this.myRef, span: this.props.field.span, style: containerStyle },
                React.createElement(TagName, { form: this.props.form, field: this.props.field, formLayout: this.props.formLayout })))));
    };
    return AntWfDragComponent;
}(Component));
// Export the wrapped version
var AntWfDragComponent$1 = DropTarget(["field", "component"], WfComponentTarget, WfComponentDropConnect)(DragSource("field", WfComponentSource, collect)(AntWfDragComponent));
// export default AntWfDragComponent;

var AntWfDragFormInner = /** @class */ (function (_super) {
    __extends(AntWfDragFormInner, _super);
    function AntWfDragFormInner(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (!err) {
                    console.log('Received values of form: ', values);
                }
            });
        };
        _this.moveField = function (dragIndex, hoverIndex) {
            // const { data } = this.state;
            var fields = _this.state.fields;
            var dragField = fields[dragIndex];
            var newFields = update(_this.state, {
                fields: {
                    $splice: [[dragIndex, 1], [hoverIndex, 0, dragField]],
                },
            });
            _this.setState(newFields);
        };
        _this.addField = function (fieldItem, addindex) {
            // if (fieldItem.)
            var newField = new AntInputField({
                key: 'userName123',
                isHorizontal: false,
                span: 12,
                label: "名字add",
                required: true
            });
            var newFields = update(_this.state, {
                fields: {
                    $splice: [[addindex, 0, newField]],
                },
            });
            console.log("fields", newFields);
            _this.setState(newFields);
        };
        _this.uimap = uimap;
        _this.state = {
            formLayout: "vertical",
            fields: props.fields
        };
        _this.formItems = [
            AntInput,
            AntTextarea,
            AntDatetimePick,
            AntTableForm,
            AntEditTableForm
        ];
        return _this;
    }
    AntWfDragFormInner.prototype.render = function () {
        var _this = this;
        var formItems = this.state.fields.map(function (field, index) { return (React.createElement(AntWfDragComponent$1, { component: _this.uimap.get(field.selector), key: field.key, index: index, form: _this.props.form, field: field, formLayout: _this.state.formLayout, moveField: _this.moveField, addField: _this.addField })); });
        return (React.createElement(Form$1, { onSubmit: this.handleSubmit, layout: this.state.formLayout, className: "login-form" },
            React.createElement(Row, { gutter: 16 }, formItems)));
    };
    return AntWfDragFormInner;
}(Component));
var AntWfDragForm = Form$1.create({ name: 'antWfForm' })(AntWfDragFormInner);

var ComponentRegitor = /** @class */ (function () {
    function ComponentRegitor() {
    }
    ComponentRegitor.registorClass = function (type) {
        ComponentRegitor.UIComponents.push(type);
        ComponentRegitor.UIComponentsMap.set(type.componentTag, type);
    };
    ComponentRegitor.UIComponents = [];
    ComponentRegitor.UIComponentsMap = new Map();
    return ComponentRegitor;
}());
var RegistorClass = ComponentRegitor.registorClass;
var UIComponents = ComponentRegitor.UIComponents || [];
var UIComponentsMap = ComponentRegitor.UIComponentsMap || {};
var SetComponent = function (fs) {
    if (fs.class) {
        var tag = fs.class.componentTag;
        if (tag && !fs.class.componentObject) {
            var classType = UIComponentsMap.get(tag);
            fs.class.componentObject = classType.componentObject;
            var defaultProps = Object.assign({}, classType.defaultProps) || {};
            fs.props = Object.assign(defaultProps, fs.props);
            fs.class.scheme = classType.scheme;
        }
    }
    if (fs.children) {
        setUIComponentsChildren(fs.children);
    }
};
var setUIComponentsChildren = function (items) {
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        if (item.children) {
            setUIComponentsChildren(item.children);
        }
        if (item.class) {
            var tag = item.class.componentTag;
            if (tag && !item.class.componentObject) {
                var classType = UIComponentsMap.get(tag);
                item.class.componentObject = classType.componentObject;
                var defaultProps = Object.assign({}, classType.defaultProps) || {};
                item.props = Object.assign(defaultProps, item.props);
                item.class.scheme = classType.scheme;
            }
        }
    }
};
var CommonScheme = {
    key: "test",
    name: "testName",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
    ]
};

var FormItemComponent = /** @class */ (function (_super) {
    __extends(FormItemComponent, _super);
    function FormItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormItemComponent.prototype.render = function () {
        var TagName = this.props.class.componentObject;
        return (React.createElement(Col$1, { span: this.props.span || 6 },
            React.createElement(TagName, __assign({ form: this.props.form, field: this.props.field, formLayout: this.props.formLayout }, this.props))));
    };
    return FormItemComponent;
}(Component));

var FormGroupComponent = /** @class */ (function (_super) {
    __extends(FormGroupComponent, _super);
    function FormGroupComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroupComponent.prototype.render = function () {
        var _this = this;
        var formItems = this.props.items.map(function (item, index) {
            var formKey = _this.props.formKey + "." + item.key;
            if (item.class) {
                return (React.createElement(FormItemComponent, __assign({ key: item.key, class: item.class }, _this.props, { formKey: formKey, index: index, name: item.name, item: item })));
            }
            else {
                return (React.createElement(FormGroupComponent, { key: item.key, items: item.children, formKey: formKey, index: index, name: item.name, item: item }));
            }
        });
        return (formItems);
    };
    return FormGroupComponent;
}(Component));

var AntInput$1 = /** @class */ (function (_super) {
    __extends(AntInput, _super);
    function AntInput(props) {
        var _this = _super.call(this, props) || this;
        _this.handleValueChange = function (value) {
        };
        return _this;
    }
    AntInput.prototype.render = function () {
        var formLayout = (this.props || "horizontal").formLayout;
        var formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement(Form.Item, __assign({}, formItemLayout, { label: this.props.label || this.props.name }), getFieldDecorator(this.props.formKey, {
            rules: [{
                    validator: this.props.validator
                    // type: this.field.validator, message: 'The input is not valid E-mail!',
                }, {
                    required: this.props.required, message: '必填项!',
                }],
        })(React.createElement(Input, { disabled: this.props.disabled, onChange: this.handleValueChange }))));
    };
    return AntInput;
}(React.Component));
var scheme = {
    key: "test",
    name: "testName",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
    ]
};
RegistorClass({
    componentTag: "AntInput",
    componentObject: AntInput$1,
    componentName: "Ant文本框",
    scheme: scheme,
    defaultProps: {
        span: 12,
        label: "文本框",
        required: false
    }
});
// export default AntInput

var TextArea$1 = Input.TextArea;
var AntTextarea$1 = /** @class */ (function (_super) {
    __extends(AntTextarea, _super);
    function AntTextarea(props) {
        return _super.call(this, props) || this;
    }
    AntTextarea.prototype.render = function () {
        var formLayout = this.props.formLayout;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null
        return (React.createElement(Form.Item, __assign({}, formItemLayout, { label: this.props.label || this.props.name }), getFieldDecorator(this.props.formKey, {
            rules: [{
                // type: this.props.validator, message: 'The input is not valid E-mail!',
                }, {
                    required: this.props.required, message: '必填项!',
                }],
        })(React.createElement(TextArea$1, { rows: 4 }))));
    };
    return AntTextarea;
}(React.Component));
var scheme$1 = Object.assign({}, CommonScheme, {
    children: CommonScheme.children.concat([
        {
            class: {
                componentTag: "AntInput",
            },
            key: "custom",
            name: "文本域自定义属性",
            props: {
                // span: 6,
                required: true,
                label: "文本域自定义属性"
            }
        },
    ])
});
RegistorClass({
    componentTag: "AntTextarea",
    componentObject: AntTextarea$1,
    componentName: "Ant文本域",
    scheme: scheme$1,
    defaultProps: {
        span: 24,
        lable: "文本域2",
        required: false
    }
});
// export default AntTextarea

var TextArea$2 = Input.TextArea;
var SubMenu = Menu.SubMenu;
var AntDropdown = /** @class */ (function (_super) {
    __extends(AntDropdown, _super);
    function AntDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showHeader: '下拉框',
        };
        return _this;
    }
    AntDropdown.prototype.render = function () {
        var _this = this;
        var formLayout = this.props.formLayout;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        // const formItemLayout = null
        var menu = (React.createElement(Menu, null,
            React.createElement(Menu.Item, null,
                React.createElement("a", { target: "_blank", rel: "noopener noreferrer", onClick: function () {
                        _this.setState({ showHeader: '1st menu item' });
                    } }, "1st menu item")),
            React.createElement(Menu.Item, null,
                React.createElement("a", { target: "_blank", rel: "noopener noreferrer", onClick: function () {
                        _this.itemClick('2ed menu item');
                    } }, "2ed menu item")),
            React.createElement(SubMenu, { title: "sub menu" },
                React.createElement(Menu.Item, null,
                    React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "http://www.baidu.com/", onClick: function () {
                            _this.itemClick('3ed menu item');
                        } }, "3st menu item")),
                React.createElement(Menu.Item, null,
                    React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "http://www.baidu.com/", onClick: function () {
                            _this.itemClick('4ed menu item');
                        } }, "4st menu item"))),
            React.createElement(SubMenu, { title: "disabled sub menu", disabled: true },
                React.createElement(Menu.Item, null,
                    React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "http://www.baidu.com/", onClick: function () {
                            _this.itemClick('5ed menu item');
                        } }, "5st menu item")),
                React.createElement(Menu.Item, null,
                    React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "http://www.baidu.com/", onClick: function () {
                            _this.itemClick('6ed menu item');
                        } }, "6st menu item")))));
        return (getFieldDecorator(this.props.formKey, {
            rules: [{
                    validator: this.props.validator
                    // type: this.field.validator, message: 'The input is not valid E-mail!',
                }, {
                    required: this.props.required, message: '必填项!',
                }],
        })(React.createElement(Dropdown, { overlay: menu },
            React.createElement("a", { className: "ant-dropdown-link", href: "#" },
                this.state.showHeader,
                React.createElement(Icon, { type: "down" })))));
    };
    AntDropdown.prototype.itemClick = function (item) {
        this.setState({ showHeader: item });
        this.props.itemClick(item);
    };
    return AntDropdown;
}(React.Component));
// RegistorClass({
//     componentTag: "Dropdown",
//     componentObject: AntDropdown,
//     componentName: "Ant下拉菜单",
//     scheme: scheme,
//     defaultProps: {
//         span: 12,
//         lable: "下拉菜单",
//         required: false
//     }
// })
// export default AntTextarea

var CheckboxGroup = Checkbox.Group;
var plainOptions = ['Apple', 'Pear', 'Orange', 'Bonana'];
var defaultCheckedList = ['Apple', 'Orange'];
var AntCheckbox = /** @class */ (function (_super) {
    __extends(AntCheckbox, _super);
    function AntCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            checkedList: defaultCheckedList,
            indeterminate: true,
            checkAll: false,
        };
        _this.onChange = function (checkedList) {
            _this.setState({
                checkedList: checkedList,
                indeterminate: !!checkedList.length && checkedList.length < plainOptions.length,
                checkAll: checkedList.length === plainOptions.length,
            });
        };
        _this.handleSizeChange = function (e) {
            _this.setState({ size: e.target.value });
        };
        return _this;
    }
    AntCheckbox.prototype.render = function () {
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var disabled = (this.props.disabled == undefined) ? false : (this.props.disabled[0] == '禁止选择') ? true : false;
        return (React.createElement("div", null,
            React.createElement("div", { style: { borderBottom: '1px solid #E9E9E9' } }),
            getFieldDecorator(this.props.formKey, {
                rules: [{
                        validator: this.props.validator
                    }, {
                        required: this.props.required, message: '必填项!',
                    }],
            })(React.createElement(CheckboxGroup, { options: (this.props.list) ? this.props.list : plainOptions, disabled: disabled, value: this.state.checkedList, onChange: this.onChange }))));
    };
    return AntCheckbox;
}(React.Component));
var scheme$2 = {
    key: "test",
    name: "testName",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
        {
            class: {
                componentTag: "Ant-CheckboxContainer",
            },
            key: "disabled",
            name: "禁止选择(是或否）",
            props: {
                // span: 6,
                label: "禁止选择(是或否）"
            }
        }
    ]
};
RegistorClass({
    componentTag: "Ant-Checkbox",
    componentObject: AntCheckbox,
    componentName: "Ant多选框",
    scheme: scheme$2,
    defaultProps: {
        span: 24,
        lable: "多选框",
        required: false
    }
});
// export default AntTextarea

var Option = Select.Option;
var AntOthers = /** @class */ (function (_super) {
    __extends(AntOthers, _super);
    function AntOthers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFields(function (err, values) {
                if (!err) {
                    console.log('Received values of form: ', values);
                }
            });
        };
        _this.normFile = function (e) {
            console.log('Upload event:', e);
            if (Array.isArray(e)) {
                return e;
            }
            return e && e.fileList;
        };
        return _this;
    }
    AntOthers.prototype.render = function () {
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        return (React.createElement(Form, __assign({}, formItemLayout, { onSubmit: this.handleSubmit }),
            React.createElement(Form.Item, { label: "Plain Text" },
                React.createElement("span", { className: "ant-form-text" }, "China")),
            React.createElement(Form.Item, { label: "Select", hasFeedback: true }, getFieldDecorator('select', {
                rules: [{ required: true, message: 'Please select your country!' }],
            })(React.createElement(Select, { placeholder: "Please select a country" },
                React.createElement(Option, { value: "china" }, "China"),
                React.createElement(Option, { value: "usa" }, "U.S.A")))),
            React.createElement(Form.Item, { label: "Select[multiple]" }, getFieldDecorator('select-multiple', {
                rules: [
                    { required: true, message: 'Please select your favourite colors!', type: 'array' },
                ],
            })(React.createElement(Select, { mode: "multiple", placeholder: "Please select favourite colors" },
                React.createElement(Option, { value: "red" }, "Red"),
                React.createElement(Option, { value: "green" }, "Green"),
                React.createElement(Option, { value: "blue" }, "Blue")))),
            React.createElement(Form.Item, { label: "InputNumber" },
                getFieldDecorator('input-number', { initialValue: 3 })(React.createElement(InputNumber, { min: 1, max: 10 })),
                React.createElement("span", { className: "ant-form-text" }, " machines")),
            React.createElement(Form.Item, { label: "Switch" }, getFieldDecorator('switch', { valuePropName: 'checked' })(React.createElement(Switch, null))),
            React.createElement(Form.Item, { label: "Slider" }, getFieldDecorator('slider')(React.createElement(Slider, { marks: {
                    0: 'A',
                    20: 'B',
                    40: 'C',
                    60: 'D',
                    80: 'E',
                    100: 'F',
                } }))),
            React.createElement(Form.Item, { label: "Radio.Group" }, getFieldDecorator('radio-group')(React.createElement(Radio.Group, null,
                React.createElement(Radio, { value: "a" }, "item 1"),
                React.createElement(Radio, { value: "b" }, "item 2"),
                React.createElement(Radio, { value: "c" }, "item 3")))),
            React.createElement(Form.Item, { label: "Radio.Button" }, getFieldDecorator('radio-button')(React.createElement(Radio.Group, null,
                React.createElement(Radio.Button, { value: "a" }, "item 1"),
                React.createElement(Radio.Button, { value: "b" }, "item 2"),
                React.createElement(Radio.Button, { value: "c" }, "item 3")))),
            React.createElement(Form.Item, { label: "Checkbox.Group" }, getFieldDecorator('checkbox-group', {
                initialValue: ['A', 'B'],
            })(React.createElement(Checkbox.Group, { style: { width: '100%' } },
                React.createElement(Row, null,
                    React.createElement(Col, { span: 8 },
                        React.createElement(Checkbox, { value: "A" }, "A")),
                    React.createElement(Col, { span: 8 },
                        React.createElement(Checkbox, { disabled: true, value: "B" }, "B")),
                    React.createElement(Col, { span: 8 },
                        React.createElement(Checkbox, { value: "C" }, "C")),
                    React.createElement(Col, { span: 8 },
                        React.createElement(Checkbox, { value: "D" }, "D")),
                    React.createElement(Col, { span: 8 },
                        React.createElement(Checkbox, { value: "E" }, "E")))))),
            React.createElement(Form.Item, { label: "Rate" }, getFieldDecorator('rate', {
                initialValue: 3.5,
            })(React.createElement(Rate, null))),
            React.createElement(Form.Item, { label: "Upload", extra: "longgggggggggggggggggggggggggggggggggg" }, getFieldDecorator('upload', {
                valuePropName: 'fileList',
                getValueFromEvent: this.normFile,
            })(React.createElement(Upload, { name: "logo", action: "/upload.do", listType: "picture" },
                React.createElement(Button, null,
                    React.createElement(Icon, { type: "upload" }),
                    " Click to upload")))),
            React.createElement(Form.Item, { label: "Dragger" }, getFieldDecorator('dragger', {
                valuePropName: 'fileList',
                getValueFromEvent: this.normFile,
            })(React.createElement(Upload.Dragger, { name: "files", action: "/upload.do" },
                React.createElement("p", { className: "ant-upload-drag-icon" },
                    React.createElement(Icon, { type: "inbox" })),
                React.createElement("p", { className: "ant-upload-text" }, "Click or drag file to this area to upload"),
                React.createElement("p", { className: "ant-upload-hint" }, "Support for a single or bulk upload.")))),
            React.createElement(Form.Item, { wrapperCol: { span: 12, offset: 6 } },
                React.createElement(Button, { type: "primary", htmlType: "submit" }, "Submit"))));
    };
    return AntOthers;
}(React.Component));
// RegistorClass({
//     componentTag: "Ant-Others",
//     componentObject: AntOthers,
//     componentName: "Ant其他组件",
//     scheme: scheme,
//     defaultProps: {
//         span: 24,
//         lable: "其他组件",
//         required: false
//     }
// })
// export default AntTextarea

var AntLogin = /** @class */ (function (_super) {
    __extends(AntLogin, _super);
    function AntLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFields(function (err, values) {
                if (!err) {
                    console.log('Received values of form: ', values);
                }
            });
        };
        return _this;
    }
    AntLogin.prototype.render = function () {
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement(Form, { onSubmit: this.handleSubmit, className: "login-form" },
            React.createElement(Form.Item, null, getFieldDecorator('username', {
                rules: [{ required: true, message: 'Please input your username!' }],
            })(React.createElement(Input, { prefix: React.createElement(Icon, { type: "user", style: { color: 'rgba(0,0,0,.25)' } }), placeholder: "Username" }))),
            React.createElement(Form.Item, null, getFieldDecorator('password', {
                rules: [{ required: true, message: 'Please input your Password!' }],
            })(React.createElement(Input, { prefix: React.createElement(Icon, { type: "lock", style: { color: 'rgba(0,0,0,.25)' } }), type: "password", placeholder: "Password" }))),
            React.createElement(Form.Item, null,
                getFieldDecorator('remember', {
                    valuePropName: 'checked',
                    initialValue: true,
                })(React.createElement(Checkbox, null, "Remember me")),
                React.createElement("a", { className: "login-form-forgot", href: "" }, "Forgot password"),
                React.createElement("br", null),
                React.createElement(Button, { type: "primary", htmlType: "submit", className: "login-form-button" }, "Log in"),
                "Or ",
                React.createElement("a", { href: "" }, "register now!"))));
    };
    return AntLogin;
}(React.Component));
var scheme$3 = Object.assign({}, CommonScheme, {});
RegistorClass({
    componentTag: "AntLogin",
    componentObject: AntLogin,
    componentName: "Ant登录框",
    scheme: scheme$3,
    defaultProps: {
        span: 12,
        lable: "登录框",
        required: false
    }
});
// export default AntInput

var Option$1 = Select.Option;
var AutoCompleteOption = AutoComplete.Option;
var residences = [
    {
        value: 'zhejiang',
        label: 'Zhejiang',
        children: [
            {
                value: 'hangzhou',
                label: 'Hangzhou',
                children: [
                    {
                        value: 'xihu',
                        label: 'West Lake',
                    },
                ],
            },
        ],
    },
    {
        value: 'jiangsu',
        label: 'Jiangsu',
        children: [
            {
                value: 'nanjing',
                label: 'Nanjing',
                children: [
                    {
                        value: 'zhonghuamen',
                        label: 'Zhong Hua Men',
                    },
                ],
            },
        ],
    },
];
var AntRegister = /** @class */ (function (_super) {
    __extends(AntRegister, _super);
    function AntRegister() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            confirmDirty: false,
            autoCompleteResult: [],
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFieldsAndScroll(function (err, values) {
                if (!err) {
                    console.log('Received values of form: ', values);
                }
            });
        };
        _this.handleConfirmBlur = function (e) {
            var value = e.target.value;
            _this.setState({ confirmDirty: _this.state.confirmDirty || !!value });
        };
        _this.compareToFirstPassword = function (rule, value, callback) {
            var form = _this.props.form;
            if (value && value !== form.getFieldValue('password')) {
                callback('Two passwords that you enter is inconsistent!');
            }
            else {
                callback();
            }
        };
        _this.validateToNextPassword = function (rule, value, callback) {
            var form = _this.props.form;
            if (value && _this.state.confirmDirty) {
                form.validateFields(['confirm'], { force: true });
            }
            callback();
        };
        _this.handleWebsiteChange = function (value) {
            var autoCompleteResult;
            if (!value) {
                autoCompleteResult = [];
            }
            else {
                autoCompleteResult = ['.com', '.org', '.net'].map(function (domain) { return "" + value + domain; });
            }
            _this.setState({ autoCompleteResult: autoCompleteResult });
        };
        return _this;
    }
    AntRegister.prototype.render = function () {
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var autoCompleteResult = this.state.autoCompleteResult;
        var formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        var tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        var prefixSelector = getFieldDecorator('prefix', {
            initialValue: '86',
        })(React.createElement(Select, { style: { width: 70 } },
            React.createElement(Option$1, { value: "86" }, "+86"),
            React.createElement(Option$1, { value: "87" }, "+87")));
        var websiteOptions = autoCompleteResult.map(function (website) { return (React.createElement(AutoCompleteOption, { key: website }, website)); });
        return (React.createElement(Form, __assign({}, formItemLayout, { onSubmit: this.handleSubmit }),
            React.createElement(Form.Item, { label: "E-mail" }, getFieldDecorator('email', {
                rules: [
                    {
                        type: 'email',
                        message: 'The input is not valid E-mail!',
                    },
                    {
                        required: true,
                        message: 'Please input your E-mail!',
                    },
                ],
            })(React.createElement(Input, null))),
            React.createElement(Form.Item, { label: "Password", hasFeedback: true }, getFieldDecorator('password', {
                rules: [
                    {
                        required: true,
                        message: 'Please input your password!',
                    },
                    {
                        validator: this.validateToNextPassword,
                    },
                ],
            })(React.createElement(Input.Password, null))),
            React.createElement(Form.Item, { label: "Confirm Password", hasFeedback: true }, getFieldDecorator('confirm', {
                rules: [
                    {
                        required: true,
                        message: 'Please confirm your password!',
                    },
                    {
                        validator: this.compareToFirstPassword,
                    },
                ],
            })(React.createElement(Input.Password, { onBlur: this.handleConfirmBlur }))),
            React.createElement(Form.Item, { label: React.createElement("span", null,
                    "Nickname\u00A0",
                    React.createElement(Tooltip, { title: "What do you want others to call you?" },
                        React.createElement(Icon, { type: "question-circle-o" }))) }, getFieldDecorator('nickname', {
                rules: [{ required: true, message: 'Please input your nickname!', whitespace: true }],
            })(React.createElement(Input, null))),
            React.createElement(Form.Item, { label: "Habitual Residence" }, getFieldDecorator('residence', {
                initialValue: ['zhejiang', 'hangzhou', 'xihu'],
                rules: [
                    { type: 'array', required: true, message: 'Please select your habitual residence!' },
                ],
            })(React.createElement(Cascader, { options: residences }))),
            React.createElement(Form.Item, { label: "Phone Number" }, getFieldDecorator('phone', {
                rules: [{ required: true, message: 'Please input your phone number!' }],
            })(React.createElement(Input, { addonBefore: prefixSelector, style: { width: '100%' } }))),
            React.createElement(Form.Item, { label: "Website" }, getFieldDecorator('website', {
                rules: [{ required: true, message: 'Please input website!' }],
            })(React.createElement(AutoComplete, { dataSource: websiteOptions, onChange: this.handleWebsiteChange, placeholder: "website" },
                React.createElement(Input, null)))),
            React.createElement(Form.Item, { label: "Captcha", extra: "We must make sure that your are a human." },
                React.createElement(Row, { gutter: 8 },
                    React.createElement(Col, { span: 12 }, getFieldDecorator('captcha', {
                        rules: [{ required: true, message: 'Please input the captcha you got!' }],
                    })(React.createElement(Input, null))),
                    React.createElement(Col, { span: 12 },
                        React.createElement(Button, null, "Get captcha")))),
            React.createElement(Form.Item, __assign({}, tailFormItemLayout), getFieldDecorator('agreement', {
                valuePropName: 'checked',
            })(React.createElement(Checkbox, null,
                "I have read the ",
                React.createElement("a", { href: "" }, "agreement")))),
            React.createElement(Form.Item, __assign({}, tailFormItemLayout),
                React.createElement(Button, { type: "primary", htmlType: "submit" }, "Register"))));
    };
    return AntRegister;
}(React.Component));
var scheme$4 = Object.assign({}, CommonScheme, {});
console.log("scheme", scheme$4);
// RegistorClass({
//     componentTag: "AntRegister",
//     componentObject: AntRegister,
//     componentName: "Ant注册框",
//     scheme: scheme,
//     defaultProps: {
//         span: 12,
//         lable: "注册框",
//         required: false
//     }
// })
// export default AntInput

var Option$2 = Select.Option;
var AntDiyForm1 = /** @class */ (function (_super) {
    __extends(AntDiyForm1, _super);
    function AntDiyForm1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleNumberChange = function (e) {
            var number = parseInt(e.target.value || 0, 10);
            if (isNaN(number)) {
                return;
            }
            _this.triggerChange({ number: number });
        };
        _this.handleCurrencyChange = function (currency) {
            _this.triggerChange({ currency: currency });
        };
        _this.triggerChange = function (changedValue) {
            var _a = _this.props, onChange = _a.onChange, value = _a.value;
            if (onChange) {
                onChange(__assign({}, value, changedValue));
            }
        };
        return _this;
    }
    AntDiyForm1.prototype.render = function () {
        var _a = this.props, size = _a.size, value = _a.value;
        return (React.createElement("span", null,
            React.createElement(Input, { type: "text", size: size, value: value.number, onChange: this.handleNumberChange, style: { width: '65%', marginRight: '3%' } }),
            React.createElement(Select, { value: value.currency, size: size, style: { width: '32%' }, onChange: this.handleCurrencyChange },
                React.createElement(Option$2, { value: "rmb" }, "RMB"),
                React.createElement(Option$2, { value: "dollar" }, "Dollar"))));
    };
    return AntDiyForm1;
}(React.Component));
var AntDiyForm = /** @class */ (function (_super) {
    __extends(AntDiyForm, _super);
    function AntDiyForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFields(function (err, values) {
                if (!err) {
                    console.log('Received values of form: ', values);
                }
            });
        };
        _this.checkPrice = function (rule, value, callback) {
            if (value.number > 0) {
                return callback();
            }
            callback('Price must greater than zero!');
        };
        return _this;
    }
    AntDiyForm.prototype.render = function () {
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement(Form, { layout: "inline", onSubmit: this.handleSubmit },
            React.createElement(Form.Item, { label: "Price" }, getFieldDecorator('price', {
                initialValue: { number: 0, currency: 'rmb' },
                rules: [{ validator: this.checkPrice }],
            })(React.createElement(AntDiyForm1, null))),
            React.createElement(Form.Item, null,
                React.createElement(Button, { type: "primary", htmlType: "submit" }, "Submit"))));
    };
    return AntDiyForm;
}(React.Component));
// RegistorClass({
//     componentTag: "AntDiyForm",
//     componentObject: AntDiyForm,
//     componentName: "自定义表单",
//     scheme: scheme,
//     defaultProps: {
//         span: 12,
//         lable: "自定义表单",
//         required: false
//     }
// })
// export default AntInput

var SubMenu$1 = Menu.SubMenu;
var AntMemu = /** @class */ (function (_super) {
    __extends(AntMemu, _super);
    function AntMemu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            theme: 'light',
            current: '1',
        };
        _this.changeTheme = function (value) {
            _this.setState({
                theme: value ? 'dark' : 'light',
            });
        };
        _this.handleClick = function (e) {
            console.log('click ', e);
            _this.setState({
                current: e.key,
            });
        };
        return _this;
    }
    AntMemu.prototype.render = function () {
        var _this = this;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement("div", null,
            React.createElement(Switch, { checked: this.state.theme === 'dark', onChange: this.changeTheme, checkedChildren: "Dark", unCheckedChildren: "Light" }),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Menu
            // theme={this.state.theme}
            , { 
                // theme={this.state.theme}
                onClick: this.handleClick, style: { width: 256 }, defaultOpenKeys: ['sub1'], selectedKeys: [this.state.current], mode: "inline", theme: (this.state.theme == 'dark') ? 'dark' : 'light' },
                React.createElement(SubMenu$1, { key: "sub1", title: React.createElement("span", null,
                        React.createElement(Icon, { type: "mail" }),
                        React.createElement("span", null, "Navigation One")) },
                    React.createElement(Menu.Item, { key: "1", onClick: function () { _this.props.itemClick('1'); } }, "Option 1"),
                    ",",
                    React.createElement(Menu.Item, { key: "2", onClick: function () { _this.props.itemClick('2'); } }, "Option 2"),
                    React.createElement(Menu.Item, { key: "3", onClick: function () { _this.props.itemClick('3'); } }, "Option 3"),
                    React.createElement(Menu.Item, { key: "4", onClick: function () { _this.props.itemClick('4'); } }, "Option 4")),
                React.createElement(SubMenu$1, { key: "sub2", title: React.createElement("span", null,
                        React.createElement(Icon, { type: "appstore" }),
                        React.createElement("span", null, "Navigation Two")) },
                    React.createElement(Menu.Item, { key: "5", onClick: function () { _this.props.itemClick('5'); } }, "Option 5"),
                    React.createElement(Menu.Item, { key: "6" },
                        "onClick=",
                        function () { _this.props.itemClick('6'); },
                        "Option 6"),
                    React.createElement(SubMenu$1, { key: "sub3", title: "Submenu" },
                        React.createElement(Menu.Item, { key: "7", onClick: function () { _this.props.itemClick('7'); } }, "Option 7"),
                        React.createElement(Menu.Item, { key: "8", onClick: function () { _this.props.itemClick('8'); } }, "Option 8"))),
                React.createElement(SubMenu$1, { key: "sub4", title: React.createElement("span", null,
                        React.createElement(Icon, { type: "setting" }),
                        React.createElement("span", null, "Navigation Three")) },
                    React.createElement(Menu.Item, { key: "9" }, "Option 9"),
                    React.createElement(Menu.Item, { key: "10" }, "Option 10"),
                    React.createElement(Menu.Item, { key: "11" }, "Option 11"),
                    React.createElement(Menu.Item, { key: "12" }, "Option 12")))));
    };
    return AntMemu;
}(React.Component));
// RegistorClass({
//     componentTag: "AntMemu",
//     componentObject: AntMemu,
//     componentName: "Ant导航栏",
//     scheme: scheme,
//     defaultProps: {
//         span: 24,
//         lable: "导航栏",
//         required: false
//     }
// })
// export default AntTextarea

var MonthPicker = DatePicker.MonthPicker, RangePicker = DatePicker.RangePicker;
var AntDatePick = /** @class */ (function (_super) {
    __extends(AntDatePick, _super);
    function AntDatePick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFields(function (err, fieldsValue) {
                if (err) {
                    return;
                }
                // Should format date value before submit.
                var rangeValue = fieldsValue['range-picker'];
                var rangeTimeValue = fieldsValue['range-time-picker'];
                var values = __assign({}, fieldsValue, { 'date-picker': fieldsValue['date-picker'].format('YYYY-MM-DD'), 'date-time-picker': fieldsValue['date-time-picker'].format('YYYY-MM-DD HH:mm:ss'), 'month-picker': fieldsValue['month-picker'].format('YYYY-MM'), 'range-picker': [rangeValue[0].format('YYYY-MM-DD'), rangeValue[1].format('YYYY-MM-DD')], 'range-time-picker': [
                        rangeTimeValue[0].format('YYYY-MM-DD HH:mm:ss'),
                        rangeTimeValue[1].format('YYYY-MM-DD HH:mm:ss'),
                    ], 'time-picker': fieldsValue['time-picker'].format('HH:mm:ss') });
                console.log('Received values of form: ', values);
            });
        };
        return _this;
    }
    AntDatePick.prototype.render = function () {
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        var config = {
            rules: [{ type: 'object', required: true, message: 'Please select time!' }],
        };
        var rangeConfig = {
            rules: [{ type: 'array', required: true, message: 'Please select time!' }],
        };
        return (React.createElement(Form, __assign({}, formItemLayout, { onSubmit: this.handleSubmit }),
            React.createElement(Form.Item, { label: "DatePicker" }, getFieldDecorator('date-picker', config)(React.createElement(DatePicker, null))),
            React.createElement(Form.Item, { label: "DatePicker[showTime]" }, getFieldDecorator('date-time-picker', config)(React.createElement(DatePicker, { showTime: true, format: "YYYY-MM-DD HH:mm:ss" }))),
            React.createElement(Form.Item, { label: "MonthPicker" }, getFieldDecorator('month-picker', config)(React.createElement(MonthPicker, null))),
            React.createElement(Form.Item, { label: "RangePicker" }, getFieldDecorator('range-picker', rangeConfig)(React.createElement(RangePicker, null))),
            React.createElement(Form.Item, { label: "RangePicker[showTime]" }, getFieldDecorator('range-time-picker', rangeConfig)(React.createElement(RangePicker, { showTime: true, format: "YYYY-MM-DD HH:mm:ss" }))),
            React.createElement(Form.Item, { label: "TimePicker" }, getFieldDecorator('time-picker', config)(React.createElement(TimePicker, null))),
            React.createElement(Form.Item, { wrapperCol: {
                    xs: { span: 24, offset: 0 },
                    sm: { span: 16, offset: 8 },
                } },
                React.createElement(Button, { type: "primary", htmlType: "submit" }, "Submit"))));
    };
    return AntDatePick;
}(React.Component));
// RegistorClass({
//     componentTag: "Ant-DatePick",
//     componentObject: AntDatePick,
//     componentName: "Ant日期选择",
//     scheme: scheme,
//     defaultProps: {
//         span: 24,
//         lable: "日期选择器",
//         required: false
//     }
// })
// export default AntTextarea

var count = 3;
var fakeDataUrl = "https://randomuser.me/api/?results=" + count + "&inc=name,gender,email,nat&noinfo";
var AntList = /** @class */ (function (_super) {
    __extends(AntList, _super);
    function AntList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            initLoading: true,
            loading: false,
            data: [],
            list: [],
        };
        _this.getData = function (callback) {
            reqwest({
                url: fakeDataUrl,
                type: 'json',
                method: 'get',
                contentType: 'application/json',
                success: function (res) {
                    callback(res);
                },
            });
        };
        _this.onLoadMore = function () {
            _this.setState({
                loading: true,
                list: _this.state.list,
            });
            _this.getData(function (res) {
                var data = _this.state.data.concat(res.results);
                _this.setState({
                    data: data,
                    list: data,
                    loading: false,
                }, function () {
                    // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
                    // In real scene, you can using public method of react-virtualized:
                    // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized
                    window.dispatchEvent(new Event('resize'));
                });
            });
        };
        return _this;
    }
    AntList.prototype.componentDidMount = function () {
        // this.getData(res => {
        var res = { "results": [{ "gender": "female", "name": { "title": "Mrs", "first": "Mathilde", "last": "Johansen" }, "email": "mathilde.johansen@example.com", "nat": "DK" }] };
        this.setState({
            initLoading: false,
            data: res.results,
            list: res.results,
        });
        // });
    };
    AntList.prototype.render = function () {
        var _a = this.state, initLoading = _a.initLoading, loading = _a.loading, list = _a.list;
        var loadMore = !initLoading && !loading ? (React.createElement("div", { style: {
                textAlign: 'center',
                marginTop: 12,
                height: 32,
                lineHeight: '32px',
            } },
            React.createElement(Button, { onClick: this.onLoadMore }, "loading more"))) : null;
        return (React.createElement(List, { className: "demo-loadmore-list", loading: initLoading, itemLayout: "horizontal", loadMore: loadMore, dataSource: list, renderItem: function (item) { return (React.createElement(List.Item, { actions: [React.createElement("a", { key: "list-loadmore-edit" }, "edit"), React.createElement("a", { key: "list-loadmore-more" }, "more")] },
                React.createElement(List.Item.Meta, { avatar: React.createElement(Avatar, { src: "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" }), title: React.createElement("a", { href: "https://ant.design" }, '我是标题'), description: "Ant Design, a design language for background applications, is refined by Ant UED Team" }))); } }));
    };
    return AntList;
}(React.Component));
// RegistorClass({
//     componentTag: "AntList",
//     componentObject: AntList,
//     componentName: "Ant列表",
//     scheme: scheme,
//     defaultProps: {
//         span: 24,
//         lable: "Ant列表",
//         required: false
//     }
// })
// export default AntTextarea

var CheckboxGroup$1 = Checkbox.Group;
var plainOptions$1 = ['禁止选择'];
var defaultCheckedList$1 = [];
var AntCheckboxContainer = /** @class */ (function (_super) {
    __extends(AntCheckboxContainer, _super);
    function AntCheckboxContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            checkedList: defaultCheckedList$1,
            indeterminate: true,
            checkAll: false,
            discribe: '禁止选择',
        };
        _this.onChange = function (checkedList) {
            _this.setState({
                checkedList: checkedList,
                indeterminate: !!checkedList.length && checkedList.length < plainOptions$1.length,
                checkAll: checkedList.length === plainOptions$1.length,
            });
        };
        _this.onCheckAllChange = function (e) {
            _this.setState({
                checkedList: e.target.checked ? plainOptions$1 : [],
                indeterminate: false,
                checkAll: e.target.checked,
            });
        };
        _this.handleSizeChange = function (e) {
            _this.setState({ size: e.target.value });
        };
        return _this;
    }
    AntCheckboxContainer.prototype.render = function () {
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement("div", null,
            React.createElement("div", { style: { borderBottom: '1px solid #E9E9E9' } }),
            getFieldDecorator(this.props.formKey, {
                rules: [{
                        validator: this.props.validator
                        // type: this.field.validator, message: 'The input is not valid E-mail!',
                    }, {
                        required: this.props.required, message: '必填项!',
                    }],
            })(React.createElement(CheckboxGroup$1, { options: plainOptions$1, 
                // disabled={(checkedList == '禁止选择') ? true : false}
                value: this.state.checkedList, onChange: this.onChange }))));
    };
    return AntCheckboxContainer;
}(React.Component));
var scheme$5 = {
    key: "testsss",
    name: "testNamesss",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
        {
            class: {
                componentTag: "Ant-Checkbox",
            },
            key: "disabled",
            name: "禁止选择(是或否）",
            props: {
                // span: 6,
                plainOptions: ['禁止选择'],
                label: "禁止选择(是或否）"
            }
        },
    ]
};
RegistorClass({
    componentTag: "Ant-CheckboxContainer",
    componentObject: AntCheckboxContainer,
    componentName: "Ant多选框2",
    scheme: scheme$5,
    defaultProps: {
        span: 24,
        lable: "多选框2",
        required: false
    }
});
// export default AntTextarea

var DynamicForm = /** @class */ (function (_super) {
    __extends(DynamicForm, _super);
    function DynamicForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        SetComponent(props.formScheme);
        _this.state = {
            formScheme: props.formScheme
        };
        return _this;
    }
    DynamicForm.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.formScheme) {
            SetComponent(nextProps.formScheme);
        }
        return null;
    };
    DynamicForm.prototype.render = function () {
        var _this = this;
        var formItems = this.props.formScheme.children.map(function (item, index) {
            if (item.class) {
                return (React.createElement(FormItemComponent, __assign({ key: item.key, formKey: item.key, name: item.name, class: item.class }, item.props, _this.props)));
            }
            else {
                return (React.createElement(FormGroupComponent, __assign({ key: item.key, formKey: item.key, name: item.name, items: item.children }, _this.props)));
            }
        });
        return (React.createElement(Form$1, null,
            React.createElement(Row$1, { gutter: 16 }, formItems)));
    };
    return DynamicForm;
}(Component));
var WrappedDynamicForm = Form$1.create({
    name: 'antWfForm',
    onValuesChange: function (props, changedValues, allValues) {
        if (props.onValuesChange) {
            props.onValuesChange(changedValues, allValues);
        }
    }
})(DynamicForm);

/*
 * action 类型
 */
var SELECT_ITEM = 'SELECT_ITEM';
/*
 * action 创建函数
 */
function selectItem(item, formKey) {
    return { type: SELECT_ITEM, item: item, formKey: formKey };
}

var style$1 = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
};
var selectedStyle = {
    position: 'relative',
    border: '1px solid #90d8c8 !important',
    background: '#e1fffe'
};
var FormItemComponent$1 = /** @class */ (function (_super) {
    __extends(FormItemComponent, _super);
    function FormItemComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.myRef = React.createRef();
        return _this;
    }
    FormItemComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, isDragging = _a.isDragging, connectDragSource = _a.connectDragSource, connectDropTarget = _a.connectDropTarget;
        var opacity = isDragging ? 0 : 1;
        var containerStyle = __assign({}, style$1, { opacity: opacity });
        var TagName = this.props.class.componentObject;
        if (this.props.isActiveItem) {
            Object.assign(containerStyle, selectedStyle);
        }
        return (React.createElement(Col$1, { span: this.props.span || 6, style: containerStyle, onClick: function () { return _this.props.onItemClick(_this.props.item, _this.props.formKey); } }, connectDropTarget(connectDragSource(React.createElement("div", null,
            React.createElement(TagName, __assign({ form: this.props.form, field: this.props.field, formLayout: this.props.formLayout }, this.props)))))));
    };
    return FormItemComponent;
}(Component));
var WfComponentTarget$1 = {
    drop: function (props, monitor) {
        var item = monitor.getItem();
        // console.log("item", item)
        if (item && item.index != undefined) {
            // hoveredItem = null
            var dragIndex = item.index;
            var hoverIndex = props.index;
            var dragFormKey = item.id;
            var hoverFormKey = props.formKey;
            // Don't replace items with themselves
            if (dragFormKey === hoverFormKey) {
                return;
            }
            // Time to actually perform the action
            props.moveField(dragIndex, hoverIndex, dragFormKey, hoverFormKey);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            monitor.getItem().index = hoverIndex;
        }
        else {
            var hoverIndex = props.index;
            props.addField(item, hoverIndex);
        }
    },
    hover: function (props, monitor, component) {
        // const item = monitor.getItem();
        // console.log("hover item", item)
        // console.log("hoveredItem", hoveredItem)
        // if (!hoveredItem && item && item.index != undefined) {
        //     const dragIndex = item.index
        //     const hoverIndex = props.index;
        //     let dragFormKey = item.id
        //     let hoverFormKey = props.formKey
        //     // Don't hover back again
        //     hoveredItem = hoverFormKey
        //     // Don't replace items with themselves
        //     if (dragFormKey === hoverFormKey) {
        //         return;
        //     }
        //     // Time to actually perform the action
        //     props.moveField(dragIndex, hoverIndex, dragFormKey, hoverFormKey);
        //     // Note: we're mutating the monitor item here!
        //     // Generally it's better to avoid mutations,
        //     // but it's good here for the sake of performance
        //     // to avoid expensive index searches.
        //     monitor.getItem().index = hoverIndex;
        //     console.log("draged", hoveredItem)
        // }
    }
};
var WfComponentDropConnect$1 = function (connect, monitor, props) { return ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}); };
var WfComponentSource$1 = {
    beginDrag: function (props) {
        // Return the data describing the dragged item
        var item = {
            id: props.formKey,
            index: props.index,
            item: props.item
        };
        return item;
    },
    endDrag: function (props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        // When dropped on a compatible target, do something
        var item = monitor.getItem();
        var dropResult = monitor.getDropResult();
        //   CardActions.moveCardToList(item.id, dropResult.listId)
    },
};
/**
 * Specifies which props to inject into your component.
 */
function collect$1(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging(),
    };
}
var FormItemDragComponent = DropTarget(["field", "component"], WfComponentTarget$1, WfComponentDropConnect$1)(DragSource("field", WfComponentSource$1, collect$1)(FormItemComponent$1));
var mapStateToProps = function (state, ownProps) {
    return {
        isActiveItem: ownProps.item === state.selectedItem
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        onItemClick: function (item, formKey) { return dispatch(selectItem(item, formKey)); }
    };
};
var FormItemDragComponent$1 = connect(mapStateToProps, mapDispatchToProps)(FormItemDragComponent);

var FormGroupDragComponentInner = /** @class */ (function (_super) {
    __extends(FormGroupDragComponentInner, _super);
    function FormGroupDragComponentInner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroupDragComponentInner.prototype.render = function () {
        var _this = this;
        var formItems = this.props.items.map(function (item, index) {
            var formKey = _this.props.formKey + "." + item.key;
            if (item.class) {
                return (React.createElement(FormItemDragComponent$1, __assign({ key: item.key, class: item.class }, _this.props, { formKey: formKey, index: index, name: item.name, item: item }, item.props)));
            }
            else {
                return (React.createElement(FormGroupDragComponent, { key: item.key, items: item.children, formKey: formKey, index: index, name: item.name, item: item }));
            }
        });
        return (React.createElement("div", { style: style$2 }, formItems));
    };
    return FormGroupDragComponentInner;
}(Component));
var style$2 = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
    width: '100%'
};
var WfComponentTarget$2 = {
    drop: function (props, monitor) {
        var item = monitor.getItem();
        // console.log("item", item)
        if (item && item.index != undefined) {
            var dragIndex = item.index;
            var hoverIndex = props.index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Time to actually perform the action
            props.moveField(dragIndex, hoverIndex);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            monitor.getItem().index = hoverIndex;
        }
        else {
            var hoverIndex = props.index;
            props.addField(item, hoverIndex);
        }
    },
};
var WfComponentDropConnect$2 = function (connect, monitor, props) { return ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}); };
var WfComponentSource$2 = {
    beginDrag: function (props) {
        // Return the data describing the dragged item
        var item = {
            id: props.formKey,
            index: props.index,
            item: props.item
        };
        return item;
    },
    endDrag: function (props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        // When dropped on a compatible target, do something
        var item = monitor.getItem();
        var dropResult = monitor.getDropResult();
        //   CardActions.moveCardToList(item.id, dropResult.listId)
    },
};
/**
 * Specifies which props to inject into your component.
 */
function collect$2(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging(),
    };
}
var FormGroupDragComponent = DropTarget(["field", "component"], WfComponentTarget$2, WfComponentDropConnect$2)(DragSource("field", WfComponentSource$2, collect$2)(FormGroupDragComponentInner));

var rootReducer = combineReducers({
    selectedItem: selectedItem,
    formKey: formKey
});
function selectedItem(state, action) {
    return action.item || {};
}
function formKey(state, action) {
    return action.formKey || null;
}

var FormItem$1 = Form.Item;
var EditableContext$1 = React.createContext({});
var EditableRow$1 = function (_a) {
    var form = _a.form, index = _a.index, props = __rest(_a, ["form", "index"]);
    return (React.createElement(EditableContext$1.Provider, { value: form },
        React.createElement("tr", __assign({}, props))));
};
var EditableFormRow$1 = Form.create()(EditableRow$1);
var EditableCell$1 = /** @class */ (function (_super) {
    __extends(EditableCell, _super);
    function EditableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editing: false,
        };
        _this.toggleEdit = function () {
            var editing = !_this.state.editing;
            _this.setState({ editing: editing }, function () {
                if (editing) {
                    _this.input.focus();
                }
            });
        };
        _this.save = function (e) {
            var _a = _this.props, record = _a.record, handleSave = _a.handleSave;
            _this.form.validateFields(function (error, values) {
                if (error && error[e.currentTarget.id]) {
                    return;
                }
                _this.toggleEdit();
                handleSave(__assign({}, record, values));
            });
        };
        return _this;
    }
    EditableCell.prototype.render = function () {
        var _this = this;
        var editing = this.state.editing;
        var _a = this.props, editable = _a.editable, dataIndex = _a.dataIndex, title = _a.title, record = _a.record, index = _a.index, handleSave = _a.handleSave, restProps = __rest(_a, ["editable", "dataIndex", "title", "record", "index", "handleSave"]);
        return (React.createElement("td", __assign({}, restProps), editable ? (React.createElement(EditableContext$1.Consumer, null, function (form) {
            _this.form = form;
            return (editing ? (React.createElement(FormItem$1, { style: { margin: 0 } }, form.getFieldDecorator(dataIndex, {
                rules: [{
                        required: true,
                        message: title + " is required.",
                    }],
                initialValue: record[dataIndex],
            })(React.createElement(Input, { ref: function (node) { return (_this.input = node); }, onPressEnter: _this.save, onBlur: _this.save })))) : (React.createElement("div", { className: "editable-cell-value-wrap", style: { paddingRight: 24 }, onClick: _this.toggleEdit }, restProps.children)));
        })) : restProps.children));
    };
    return EditableCell;
}(React.Component));
var AntEditTable$1 = /** @class */ (function (_super) {
    __extends(AntEditTable, _super);
    function AntEditTable(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTableChange = function (pagination, filters, sorter) {
            // const pager = { ...this.state.pagination };
            // pager.current = pagination.current;
            // this.setState({
            //     pagination: pager,
            // });
            // this.fetch({
            //     results: pagination.pageSize,
            //     page: pagination.current,
            //     sortField: sorter.field,
            //     sortOrder: sorter.order,
            //     ...filters,
            // });
        };
        _this.handleDelete = function (key) {
            var data = _this.state.data.slice();
            var newDatas = data.filter(function (item) { return item.key !== key; });
            _this.setState({ data: newDatas });
            var onChange = _this.props.onChange;
            if (onChange) {
                // onChange(Object.assign({}, this.state.data, []));
                onChange(Object.assign([], newDatas, []));
            }
        };
        _this.handleAdd = function () {
            var _a = _this.state, total = _a.total, data = _a.data;
            var newData = {
                key: total,
                name: "Edward King " + total,
                age: 32,
                address: "London, Park Lane no. " + total,
            };
            var newdatas = data.concat([newData]);
            _this.setState({
                data: newdatas,
                total: total + 1,
            });
            var onChange = _this.props.onChange;
            if (onChange) {
                // onChange(Object.assign({}, this.state.data, []));
                onChange(Object.assign([], newdatas, []));
            }
        };
        _this.handleSave = function (row) {
            var newData = _this.state.data.slice();
            var index = newData.findIndex(function (item) { return row.key === item.key; });
            var item = newData[index];
            newData.splice(index, 1, __assign({}, item, row));
            _this.setState({
                data: newData
            });
            var onChange = _this.props.onChange;
            if (onChange) {
                // onChange(Object.assign({}, this.state.data, []));
                onChange(Object.assign([], newData, []));
            }
        };
        _this.columns = [{
                title: 'name',
                dataIndex: 'name',
                width: '30%',
                editable: true,
            }, {
                title: 'age',
                dataIndex: 'age',
                editable: true
            }, {
                title: 'address',
                dataIndex: 'address',
                editable: true
            }, {
                title: 'operation',
                dataIndex: 'operation',
                render: function (text, record) { return (_this.state.data.length >= 1
                    ? (React.createElement(Popconfirm, { title: "Sure to delete?", onConfirm: function () { return _this.handleDelete(record.key); } },
                        React.createElement("a", { href: "javascript:;" }, "Delete"))) : null); },
            }];
        _this.state = {
            data: [{
                    key: '0',
                    name: 'Edward King 0',
                    age: '32',
                    address: 'London, Park Lane no. 0',
                }, {
                    key: '1',
                    name: 'Edward King 1',
                    age: '32',
                    address: 'London, Park Lane no. 1',
                }],
            total: 2,
        };
        return _this;
    }
    AntEditTable.getDerivedStateFromProps = function (nextProps) {
        // Should be a controlled component.
        if ('value' in nextProps) {
            var datas = (nextProps.value || []).slice();
            return {
                data: datas
            };
        }
        return null;
    };
    AntEditTable.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        var components = {
            body: {
                row: EditableFormRow$1,
                cell: EditableCell$1,
            },
        };
        var columns = this.columns.map(function (col) {
            if (!col.editable) {
                return col;
            }
            return __assign({}, col, { onCell: function (record) { return ({
                    record: record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: _this.handleSave,
                }); } });
        });
        return (React.createElement("div", null,
            React.createElement(Button, { onClick: this.handleAdd, type: "primary", style: { marginBottom: 16 } }, "Add a row"),
            React.createElement(Table, { components: components, rowClassName: function () { return 'editable-row'; }, bordered: true, dataSource: data, columns: columns, onChange: this.handleTableChange })));
    };
    return AntEditTable;
}(React.Component));
var AntTableForm$1 = /** @class */ (function (_super) {
    __extends(AntTableForm, _super);
    function AntTableForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            data: []
        };
        return _this;
    }
    AntTableForm.prototype.render = function () {
        var formLayout = this.props.formLayout;
        var getFieldDecorator = this.props.form.getFieldDecorator;
        var formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        return (React.createElement(Form.Item, __assign({}, formItemLayout, { label: this.props.label }), getFieldDecorator(this.props.formKey, {
            rules: [
            // {
            // validator: this.field.validator,
            // type: this.field.validator, message: 'The input is not valid E-mail!',
            // type: 'array'
            // },
            // {
            //     required: this.field.required, message: '必填项!',
            //     type: 'array'
            // }
            ],
        })(React.createElement(AntEditTable$1, null))));
    };
    return AntTableForm;
}(React.Component));
var scheme$6 = {
    key: "test",
    name: "testName",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
    ]
};
RegistorClass({
    componentTag: "AntTable",
    componentObject: AntTableForm$1,
    componentName: "Ant表格",
    scheme: scheme$6,
    defaultProps: {
        span: 24,
        lable: "Ant表框",
        required: false
    }
});

var MdInput = /** @class */ (function (_super) {
    __extends(MdInput, _super);
    function MdInput(props) {
        var _this = _super.call(this, props) || this;
        _this.handleValueChange = function (value) {
        };
        return _this;
    }
    MdInput.prototype.render = function () {
        var formLayout = (this.props || "horizontal").formLayout;
        var formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null
        var getFieldDecorator = this.props.form.getFieldDecorator;
        return (React.createElement(Form.Item, __assign({}, formItemLayout, { label: this.props.label || this.props.name }), getFieldDecorator(this.props.formKey, {
            rules: [{
                    validator: this.props.validator
                    // type: this.field.validator, message: 'The input is not valid E-mail!',
                }, {
                    required: this.props.required, message: '必填项!',
                }],
        })(React.createElement(TextField, { disabled: this.props.disabled, fullWidth: true, onChange: this.handleValueChange }))));
    };
    return MdInput;
}(React.Component));
var scheme$7 = {
    key: "test",
    name: "testName",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
    ]
};
RegistorClass({
    componentTag: "MdInput",
    componentObject: MdInput,
    componentName: "Md文本框",
    scheme: scheme$7,
    defaultProps: {
        span: 12,
        label: "Md文本框",
        required: false
    }
});
// export default AntInput

var store = createStore(rootReducer);
var DynamicDragForm = /** @class */ (function (_super) {
    __extends(DynamicDragForm, _super);
    function DynamicDragForm(props) {
        var _this = _super.call(this, props) || this;
        _this.moveField = function (dragIndex, hoverIndex, dragFormKey, hoverFormKey) {
            var dragObject = _this.getItemList(dragFormKey);
            var hoverObject = _this.getItemList(hoverFormKey);
            var dragList = dragObject.list;
            var hoverList = hoverObject.list;
            var dragItem = dragList[dragIndex];
            if (_this.dragToKeyExist(dragItem, hoverIndex, hoverList)) {
                alert("key值冲突,请修改key值");
                return;
            }
            // dragList.splice(dragIndex, 1)
            // hoverList.splice(hoverIndex, 0, dragItem)
            // dragObject.parentObject.children = dragList
            // hoverObject.parentObject.children = hoverList
            dragObject.parentObject.children = update(dragObject.parentObject.children, {
                $splice: [[dragIndex, 1]],
            });
            hoverObject.parentObject.children = update(hoverObject.parentObject.children, {
                $splice: [[hoverIndex, 0, dragItem]],
            });
            // const children = this.state.formScheme.children
            // const dragField = children[dragIndex];
            // const newformScheme: any = update(this.state.formScheme, {
            //     children: {
            //         $splice: [[dragIndex, 1], [hoverIndex, 0, dragField]],
            //     },
            // })
            _this.setState({
                formScheme: update(_this.state.formScheme, {
                    $merge: _this.state.formScheme
                })
            });
            _this.onFormSchemeChange();
        };
        _this.addField = function (item, addindex) {
            // if (fieldItem.)
            var newItem = _this.getField(item);
            var newformScheme = update(_this.state.formScheme, {
                children: {
                    $splice: [[addindex, 0, newItem]],
                },
            });
            // console.log("fields", newFields)
            _this.setState({
                formScheme: update(_this.state.formScheme, {
                    $merge: newformScheme
                })
            });
            _this.onFormSchemeChange();
        };
        _this.itemClick = function (item, addindex) {
            // if (fieldItem.)
            alert(item);
        };
        _this.fieldSeq = 0;
        SetComponent(props.formScheme);
        _this.state = {
            formScheme: props.formScheme
        };
        var onSelectChange = function (item, formKey) { };
        if (props.onSelectChange) {
            onSelectChange = props.onSelectChange;
        }
        var unsubscribe = store.subscribe(function () {
            // console.log("store.getState().selectedItem", store.getState().selectedItem)
            onSelectChange(store.getState().selectedItem, store.getState().formKey);
        });
        return _this;
    }
    DynamicDragForm.prototype.dragToKeyExist = function (dragItem, hoverIndex, hoverList) {
        return hoverList.find(function (item, index) {
            return dragItem.key === item.key
                && hoverIndex === index;
        });
    };
    DynamicDragForm.prototype.getItemList = function (formKey) {
        var curList = this.state.formScheme.children;
        var parentObject = this.state.formScheme;
        var keys = formKey.split(".");
        var _loop_1 = function (index) {
            var curKey = keys[index];
            var item = curList.find(function (item) {
                return item.key === curKey;
            });
            if (item.children) {
                curList = item.children;
                parentObject = item;
            }
        };
        for (var index = 0; index < keys.length; index++) {
            _loop_1(index);
        }
        return {
            list: curList,
            parentObject: parentObject
        };
    };
    DynamicDragForm.prototype.getField = function (item) {
        var seq = this.fieldSeq++;
        return {
            key: item.componentTag + seq,
            name: (item.componentName || item.componentTag) + seq,
            class: item,
            props: item.defaultProps || {}
        };
    };
    DynamicDragForm.prototype.onFormSchemeChange = function (formScheme) {
        if (this.props.onFormSchemeChange) {
            this.props.onFormSchemeChange(this.state.formScheme);
        }
    };
    DynamicDragForm.prototype.render = function () {
        var _this = this;
        var formItems = this.state.formScheme.children.map(function (item, index) {
            if (item.class) {
                return (React.createElement(FormItemDragComponent$1, __assign({ key: item.key, formKey: item.key, name: item.name, class: item.class }, item.props, _this.props, { item: item, index: index, moveField: _this.moveField, addField: _this.addField, itemClick: _this.itemClick })));
            }
            else {
                return (React.createElement(FormGroupDragComponent, __assign({ key: item.key, formKey: item.key, name: item.name, items: item.children }, _this.props, { item: item, index: index, moveField: _this.moveField, addField: _this.addField, itemClick: _this.itemClick })));
            }
        });
        return (React.createElement(Provider, { store: store },
            React.createElement(Form$1, null,
                React.createElement(Row$1, { gutter: 16, type: "flex", justify: "start" }, formItems))));
    };
    return DynamicDragForm;
}(Component));
var WrappedDynamicDragForm = Form$1.create({ name: 'antWfForm' })(DynamicDragForm);

var FormScheme = /** @class */ (function () {
    function FormScheme() {
    }
    return FormScheme;
}());
var Type;
(function (Type) {
    Type[Type["FormItem"] = 0] = "FormItem";
    Type[Type["FormGroup"] = 1] = "FormGroup";
})(Type || (Type = {}));
var FormItem$2 = /** @class */ (function () {
    function FormItem() {
        this.type = Type.FormItem;
    }
    return FormItem;
}());
var FormGroup = /** @class */ (function () {
    function FormGroup() {
        this.type = Type.FormGroup;
    }
    return FormGroup;
}());

// import FormScheme from '../../../dist/lib/dform/core/FormScheme';
// formScheme in the drag form, can not in class instance? Object is not extensible
var innerFormScheme;
var DynamicFormDragBuilder = /** @class */ (function (_super) {
    __extends(DynamicFormDragBuilder, _super);
    function DynamicFormDragBuilder(props) {
        var _this = _super.call(this, props) || this;
        _this.formScheme = {
            key: "test",
            name: "testName",
            props: {},
            children: [
                {
                    class: {
                        componentTag: "AntTextarea",
                    },
                    key: "item2",
                    name: "文本域",
                    props: {
                        // span: 6,
                        label: "我的label"
                    }
                },
                {
                    class: {
                        componentTag: "AntTable",
                    },
                    key: "anttable",
                    name: "AntTable",
                    props: {
                        // span: 6,
                        label: "我的Table"
                    }
                },
                {
                    key: "users",
                    name: "用户",
                    children: [
                        {
                            class: {
                                componentTag: "AntInput",
                            },
                            key: "item111",
                            name: "名字",
                            props: {
                                label: "item111 Label",
                                disabled: true
                            }
                        },
                        {
                            class: {
                                componentTag: "AntTextarea",
                            },
                            key: "item222",
                            name: "文本域",
                            props: {
                                required: true
                            }
                        }
                    ]
                }
            ]
        };
        _this.handleClick = function (e) {
            e.preventDefault();
            var value = _this.form.getFieldsValue();
            _this.form.validateFieldsAndScroll(function (err, values) {
                if (!err) {
                    console.log('Received values of form: ', values);
                }
            });
            _this.setState({ formValue: JSON.stringify(value) });
        };
        _this.handleSetClick = function (e) {
            var tablevalue = [{ "key": 2333, "name": "设置行", "age": 32, "address": "London, Park Lane no. 2" }];
            _this.form.setFieldsValue({
                userName2: "setedValue",
                class: "22",
                anttable: tablevalue
                // datetime: "2019-04-25T05:47:13.396Z"
            });
        };
        _this.onFormItemSelectChange = function (item, formKey) {
            var formItem = _this.getItemByFormKey(formKey);
            _this.curParent = formItem.parentObject;
            _this.curItem = item;
            _this.setState({
                propFormScheme: item.class.scheme
            });
            _this.isPropsValueSetting = true;
            setTimeout(function () {
                _this.propForm.setFieldsValue(item.props);
            });
        };
        _this.isPropsValueSetting = false;
        _this.onPropValuesChange = function (changeValue, allValues) {
            // first time init the props form values
            if (_this.isPropsValueSetting) {
                _this.isPropsValueSetting = false;
            }
            else {
                _this.curItem.props = allValues;
                // trigger update
                _this.setState({});
            }
        };
        _this.state = {
            formValue: "",
            propFormScheme: {
                key: "test",
                name: "testName",
                props: {},
                children: []
            }
        };
        _this.UIComponents = UIComponents;
        innerFormScheme = _this.formScheme;
        return _this;
    }
    DynamicFormDragBuilder.prototype.getItemByFormKey = function (formKey) {
        var curList = innerFormScheme.children;
        var curItem = innerFormScheme;
        var parentObject = innerFormScheme;
        var keys = formKey.split(".");
        var _loop_1 = function (index) {
            var curKey = keys[index];
            var item = curList.find(function (item) {
                return item.key === curKey;
            });
            var isLastKey = (index == (keys.length - 1));
            if (item) {
                curItem = item;
                if (!isLastKey) {
                    if (item.children) {
                        curList = item.children;
                        parentObject = item;
                    }
                    else {
                        return { value: null };
                    }
                }
            }
            else {
                return { value: null };
            }
        };
        for (var index = 0; index < keys.length; index++) {
            var state_1 = _loop_1(index);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return {
            item: curItem,
            parentObject: parentObject
        };
    };
    DynamicFormDragBuilder.prototype.onFormSchemeChange = function (fs) {
        innerFormScheme = fs;
    };
    DynamicFormDragBuilder.prototype.render = function () {
        var _this = this;
        return (React.createElement(Row$1, { gutter: 16, type: "flex" },
            React.createElement(Col$1, { span: 6 },
                React.createElement("span", null, "\u57FA\u672C\u5B57\u6BB5"),
                React.createElement(List$1, { grid: { gutter: 4, column: 2 }, dataSource: this.UIComponents, renderItem: function (item) { return (React.createElement(DragComponentItem, { item: item })); } })),
            React.createElement(Col$1, { span: 12 },
                React.createElement("div", null,
                    React.createElement(WrappedDynamicDragForm, { formScheme: this.formScheme, wrappedComponentRef: function (c) {
                            if (c && c.props.form) {
                                _this.form = c.props.form;
                            }
                        }, onSelectChange: this.onFormItemSelectChange, onFormSchemeChange: this.onFormSchemeChange }),
                    React.createElement(Button$1, { type: "primary", onClick: this.handleSetClick }, "\u503C\u8BBE\u7F6E"),
                    React.createElement(Button$1, { type: "primary", onClick: this.handleClick }, "\u6821\u9A8C\u53D6\u503C"),
                    React.createElement("div", null, this.state.formValue))),
            React.createElement(Col$1, { span: 6 },
                React.createElement("div", null,
                    React.createElement("span", null, "\u5B57\u6BB5\u5C5E\u6027"),
                    React.createElement(WrappedDynamicForm, { formScheme: this.state.propFormScheme, wrappedComponentRef: function (c) {
                            if (c && c.props.form) {
                                _this.propForm = c.props.form;
                                console.log(_this.propForm);
                            }
                        }, onValuesChange: this.onPropValuesChange })))));
    };
    return DynamicFormDragBuilder;
}(Component));
var ComponentsSource = {
    beginDrag: function (props) {
        // Return the data describing the dragged item
        var item = props.item;
        return item;
    },
    endDrag: function (props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        // When dropped on a compatible target, do something
        var item = monitor.getItem();
        var dropResult = monitor.getDropResult();
        //   CardActions.moveCardToList(item.id, dropResult.listId)
    },
};
/**
 * Specifies which props to inject into your component.
 */
function componentCollect(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging(),
    };
}
var style$3 = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
};
var DragComponentListItem = /** @class */ (function (_super) {
    __extends(DragComponentListItem, _super);
    function DragComponentListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    DragComponentListItem.prototype.render = function () {
        var _a = this.props, isDragging = _a.isDragging, connectDragSource = _a.connectDragSource;
        var opacity = isDragging ? 0 : 1;
        // const containerStyle = useMemo(() => ({ ...style, opacity }), [opacity])
        var containerStyle = __assign({}, style$3, { opacity: opacity });
        return (connectDragSource(React.createElement("div", null,
            React.createElement(List$1.Item, { style: containerStyle },
                React.createElement(Card, null, this.props.item.componentName)))));
    };
    return DragComponentListItem;
}(Component));
var DragComponentItem = DragSource("component", ComponentsSource, componentCollect)(DragComponentListItem);

var ModalComponent = /** @class */ (function (_super) {
    __extends(ModalComponent, _super);
    function ModalComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.footerActions = [ModalAction.SAVE, ModalAction.CANCEL];
        _this.showModal = function () {
            _this.setState({
                visible: true,
            });
        };
        _this.handleOk = function (action) {
            var _a, _b;
            var result = _this.child.onModalClose(action);
            if (result instanceof Promise) {
                _this.setState({ loading: (_a = {}, _a[action.key] = true, _a) });
                result.then(function (data) {
                    var _a, _b;
                    if (data == 'success') {
                        _this.setState({ loading: (_a = {}, _a[action.key] = false, _a), visible: false, });
                        _this.onClose();
                    }
                    else if (data == 'error') {
                        _this.setState({ loading: (_b = {}, _b[action.key] = false, _b), visible: true, });
                    }
                });
            }
            else {
                _this.setState({ loading: (_b = {}, _b[action.key] = false, _b), visible: true, });
            }
        };
        _this.handleCancel = function (action) {
            var _a, _b;
            var result = _this.child.onModalDismiss(action);
            if (result instanceof Promise) {
                _this.setState({ loading: (_a = {}, _a[action.key] = true, _a) });
                result.then(function (data) {
                    var _a;
                    _this.onDismiss();
                    _this.setState({ loading: (_a = {}, _a[action.key] = false, _a), visible: false, });
                });
            }
            else {
                _this.setState({ loading: (_b = {}, _b[action.key] = false, _b), visible: false, });
            }
        };
        _this.handleAction = function (action) {
            var _a, _b;
            if (action.isClose) {
                _this.handleOk(action);
            }
            else if (action.isCancel) {
                _this.handleCancel(action);
            }
            else {
                var result = _this.child.onModalAction(action);
                if (result instanceof Promise) {
                    _this.setState({ loading: (_a = {}, _a[action.key] = true, _a) });
                    result.then(function (data) {
                        var _a;
                        _this.setState({ loading: (_a = {}, _a[action.key] = false, _a), visible: false, });
                    });
                }
                else {
                    _this.setState({ loading: (_b = {}, _b[action.key] = false, _b), visible: false, });
                }
            }
        };
        _this.bindRef = function (ref) {
            debugger;
            _this.child = ref;
        };
        _this.state = {
            ModalText: 'Content of the modal',
            visible: true,
            loading: {},
        };
        _this.onClose = _this.props.onOk ? _this.props.onOk : function () { };
        _this.onDismiss = _this.props.onDismiss ? _this.props.onDismiss : function () { };
        if (_this.props.modalActions) {
            _this.footerActions = _this.props.modalActions;
        }
        debugger;
        _this.data = _this.props.data;
        _this.C = _this.props.component;
        _this.modalTitle = _this.props.title;
        return _this;
    }
    ModalComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, onCancel = _a.onCancel, onOk = _a.onOk, close = _a.close, zIndex = _a.zIndex, afterClose = _a.afterClose, visible = _a.visible, keyboard = _a.keyboard, centered = _a.centered, getContainer = _a.getContainer, maskStyle = _a.maskStyle, okButtonProps = _a.okButtonProps, cancelButtonProps = _a.cancelButtonProps, _b = _a.iconType;
        var footerItems = [];
        if (this.props.modalActions) {
            footerItems = this.props.modalActions.map(function (action) { return (React.createElement(Button, { key: action.key, type: action.isClose ? 'primary' : 'default', loading: _this.state.loading[action.key], onClick: function (e) { _this.handleAction(action); } }, action.name)); });
        }
        else {
            footerItems = this.footerActions.map(function (action) { return (React.createElement(Button, { key: action.key, type: action.isClose ? 'primary' : 'default', loading: _this.state.loading[action.key], onClick: function (e) { _this.handleAction(action); } }, action.name)); });
        }
        var C = this.C;
        var modalChildProps = {
            data: this.data,
            functions: {
            // onClose: this.onActionClose,
            // onDismiss: this.onActionDismiss,
            // onAction: this.onAction
            },
            triggerRef: this.bindRef
        };
        var child = React.createElement(C, __assign({}, modalChildProps));
        return (React.createElement(Modal, { title: this.modalTitle, visible: this.state.visible, onOk: this.handleOk, onCancel: this.handleCancel, afterClose: afterClose, footer: footerItems }, child));
    };
    return ModalComponent;
}(Component));

var AntModalService = /** @class */ (function (_super) {
    __extends(AntModalService, _super);
    function AntModalService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AntModalService.prototype.openConfirm = function (modalOptions, success, dismiss) {
        throw new Error("Method not implemented.");
    };
    AntModalService.prototype.open = function (config, success, dismiss) {
        var div = document.createElement('div');
        document.body.appendChild(div);
        function destroy() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var unmountResult = ReactDOM.unmountComponentAtNode(div);
            if (unmountResult && div.parentNode) {
                div.parentNode.removeChild(div);
            }
            var triggerCancel = args.some(function (param) { return param && param.triggerCancel; });
            // if (config.onCancel && triggerCancel) {
            //     config.onCancel(...args);
            // }
            // for (let i = 0; i < destroyFns.length; i++) {
            //     const fn = destroyFns[i];
            //     if (fn === close) {
            //         destroyFns.splice(i, 1);
            //         break;
            //     }
            // }
        }
        function render(props) {
            ReactDOM.render(React.createElement(ModalComponent, __assign({}, props)), div);
        }
        var currentConfig = __assign({}, config, { onOk: success, onDismiss: dismiss, afterClose: destroy.bind(this), visible: true });
        render(currentConfig);
    };
    AntModalService.prototype.destroy = function () {
        throw new Error("Method not implemented.");
    };
    return AntModalService;
}(EuModalService));
var ModalService = new AntModalService();

var AntTable = /** @class */ (function (_super) {
    __extends(AntTable, _super);
    function AntTable(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [];
        _this.normalActions = [];
        _this.inlineActions = [];
        _this.curSize = 10;
        _this.curIndex = 1;
        _this.handleTableChange = function (pagination, filters, sorter) {
            var pager = __assign({}, _this.state.pagination);
            pager.current = pagination.current;
            _this.setState({
                pagination: pager,
            });
            _this.curIndex = pagination.current;
            _this.curSize = pagination.pageSize;
            _this.fetchData(pagination.pageSize, pagination.current);
        };
        _this.handleDelete = function (key) {
            var data = _this.state.data.slice();
            var newDatas = data.filter(function (item) { return item.key !== key; });
            _this.setState({ data: newDatas });
        };
        _this.handleAdd = function () {
            var _a = _this.state, total = _a.total, data = _a.data;
            var newData = {
                key: total,
                name: "name " + total,
                age: 32,
                address: "addr. " + total,
            };
            var newdatas = data.concat([newData]);
            _this.setState({
                data: newdatas,
                total: total + 1,
            });
        };
        _this.handleSave = function (row) {
            var newData = _this.state.data.slice();
            var index = newData.findIndex(function (item) { return row.key === item.key; });
            var item = newData[index];
            newData.splice(index, 1, __assign({}, item, row));
            _this.setState({
                data: newData
            });
        };
        _this.onSelectChange = function (selectedRowKeys) {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            _this.setState({ selectedRowKeys: selectedRowKeys });
        };
        _this.onRow = function (record) {
            return {
                onClick: function (event) {
                    if (_this.gridOptions.onRowClick) {
                        _this.gridOptions.onRowClick(record[_this.gridOptions.primaryKey], record, undefined);
                    }
                },
                onDoubleClick: function (event) {
                    if (_this.gridOptions.onRowDoubleClick) {
                        _this.gridOptions.onRowDoubleClick(record[_this.gridOptions.primaryKey], record, undefined);
                    }
                },
                onContextMenu: function (event) {
                    if (_this.gridOptions.onRowContextMenu) {
                        _this.gridOptions.onRowContextMenu(record[_this.gridOptions.primaryKey], record, undefined);
                    }
                },
                onMouseEnter: function (event) {
                    if (_this.gridOptions.onRowMouseEnter) {
                        _this.gridOptions.onRowMouseEnter(record[_this.gridOptions.primaryKey], record, undefined);
                    }
                },
                onMouseLeave: function (event) {
                    if (_this.gridOptions.onRowMouseLeave) {
                        _this.gridOptions.onRowMouseLeave(record[_this.gridOptions.primaryKey], record, undefined);
                    }
                },
            };
        };
        var initData = [];
        if (props.gridOptions.initData) {
            initData = props.gridOptions.initData;
        }
        _this.url = _this.props.gridOptions.url;
        _this.gridOptions = _this.props.gridOptions;
        _this.state = {
            selectedRowKeys: [],
            loading: false,
            data: initData,
            total: 0,
            pagination: {
                pageSize: _this.gridOptions.rowNum
            }
        };
        _this.columns = _this.props.columns.map(function (col) {
            return {
                title: col.title,
                dataIndex: col.field,
                render: col.render ? col.render.bind(_this) : null,
                editable: !!col.editable,
                sortDirections: ['descend'],
            };
        });
        _this.pageService = props.pageService;
        _this.modalService = props.modalService == null ? ModalService : props.modalService;
        _this.defaultActionModalConfig = _this.props.gridOptions.defaultActionModalConfig;
        _this.setActions(_this.props.gridOptions.actions);
        return _this;
    }
    AntTable.prototype.setActions = function (actions) {
        if (actions) {
            for (var index = 0; index < actions.length; index++) {
                var element = actions[index];
                if (element.type === "normal") {
                    this.normalActions.push(element);
                }
                else if (element.type === "inline") {
                    this.inlineActions.push(element);
                }
            }
        }
    };
    // static getDerivedStateFromProps(props, states) {
    // }
    AntTable.prototype.componentDidMount = function () {
        this.fetchData(this.gridOptions.rowNum, 1);
    };
    AntTable.prototype.fetchData = function (pageSize, pageIndex) {
        var _this = this;
        this.setState({
            loading: true
        });
        var size = pageSize || this.curSize;
        var index = pageIndex || this.curIndex;
        this.pageService.getPage(this.url, size, index).then(function (data) {
            debugger;
            var pagination = __assign({}, _this.state.pagination);
            // Read total count from server
            // pagination.total = data.totalCount;
            pagination.total = data.total;
            _this.setState({
                loading: false,
                data: data.contents,
                pagination: pagination
            });
        });
    };
    AntTable.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        var components = {
            body: {
                row: this.props.gridOptions.rowDragManaged ? DragableFormRow : EditableFormRow$2,
                cell: EditableCell$2,
            },
        };
        var columns = this.columns.map(function (col) {
            if (!col.editable) {
                return col;
            }
            return __assign({}, col, { onCell: function (record) { return ({
                    record: record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: _this.handleSave,
                }); } });
        });
        if (this.inlineActions.length > 0) {
            columns.push({
                title: "操作",
                render: function (text, data, index) {
                    var inlineActionItems = _this.inlineActions.map(function (action, index, all) { return (React.createElement(React.Fragment, null,
                        React.createElement("a", { href: "javascript:;", onClick: function (e) { _this.handleAction(action, text, data, index); } }, action.name),
                        index == all.length - 1 ? React.createElement(React.Fragment, null) : React.createElement(Divider, { type: "vertical" }))); });
                    return (React.createElement("span", null, inlineActionItems));
                },
                editable: false
            });
        }
        var normalActionItems = new Array();
        if (this.normalActions.length > 0) {
            normalActionItems = this.normalActions.map(function (action, index, all) {
                debugger;
                return (React.createElement(React.Fragment, null,
                    React.createElement(Button, { icon: action.icon, onClick: function (e) { _this.handleAction(action); }, type: "primary", style: { marginBottom: 16, marginRight: 16 } }, action.name)));
            });
        }
        var _a = this.state, loading = _a.loading, selectedRowKeys = _a.selectedRowKeys;
        // const rowSelection = {
        //     selectedRowKeys,
        //     onChange: this.onSelectChange,
        // };
        var rowSelection = this.props.rowSelection ? this.props.rowSelection : undefined;
        return (React.createElement("div", null,
            normalActionItems,
            React.createElement(DndProvider, { backend: HTML5Backend },
                React.createElement(Table, { onRow: this.onRow, components: components, rowClassName: function () { return 'editable-row'; }, pagination: this.state.pagination, bordered: true, dataSource: data, columns: columns, onChange: this.handleTableChange, loading: this.state.loading, rowSelection: rowSelection }))));
    };
    AntTable.prototype.handleAction = function (action, text, data, index) {
        var _this = this;
        var type = CURDAction.TYPE_READ;
        var curdType = action.curdType;
        var component = action.modalConfig ?
            action.modalConfig.component ? action.modalConfig.component : action.modalConfig.message
            : undefined;
        if (!component) {
            component = this.defaultActionModalConfig ? this.defaultActionModalConfig.component : undefined;
        }
        switch (curdType) {
            case CURDAction.TYPE_UPDATE:
                this.modalService.open({
                    viewContainerRef: undefined,
                    component: component,
                    data: data,
                    title: action.name,
                }, function (value) { _this.fetchData(); }, function (values) {
                    debugger;
                });
                break;
            case CURDAction.TYPE_CREATE:
                this.modalService.open({
                    viewContainerRef: undefined,
                    component: component,
                    data: data,
                    title: action.name,
                }, function (value) {
                    debugger;
                    _this.fetchData();
                }, function (value) {
                    debugger;
                });
                break;
            case CURDAction.TYPE_READ:
                debugger;
                this.fetchData();
                break;
            case CURDAction.TYPE_DELETE:
                this.modalService.open({
                    viewContainerRef: undefined,
                    component: component,
                    data: data,
                    title: action.name,
                }, function (value) { _this.fetchData(); }, function () { });
                break;
        }
    };
    return AntTable;
}(React.Component));
var dragingIndex = -1;
var BodyRow = /** @class */ (function (_super) {
    __extends(BodyRow, _super);
    function BodyRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BodyRow.prototype.render = function () {
        var _a = this.props, isOver = _a.isOver, connectDragSource = _a.connectDragSource, connectDropTarget = _a.connectDropTarget, moveRow = _a.moveRow, restProps = __rest(_a, ["isOver", "connectDragSource", "connectDropTarget", "moveRow"]);
        var style = __assign({}, restProps.style, { cursor: 'move' });
        var className = restProps.className;
        if (isOver) {
            if (restProps.index > dragingIndex) {
                className += ' drop-over-downward';
            }
            if (restProps.index < dragingIndex) {
                className += ' drop-over-upward';
            }
        }
        return connectDragSource(connectDropTarget(React.createElement("tr", __assign({}, restProps, { className: className, style: style }))));
    };
    return BodyRow;
}(React.Component));
var rowSource = {
    beginDrag: function (props) {
        dragingIndex = props.index;
        return {
            index: props.index,
        };
    },
};
var rowTarget = {
    drop: function (props, monitor) {
        debugger;
        var dragIndex = monitor.getItem().index;
        var hoverIndex = props.index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }
        // Time to actually perform the action
        props.moveRow(dragIndex, hoverIndex);
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
};
var DragableBodyRow = DropTarget('row', rowTarget, function (connect, monitor) { return ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}); })(DragSource('row', rowSource, function (connect) {
    return {
        connectDragSource: connect.dragSource(),
    };
})(BodyRow));
var FormItem$3 = Form.Item;
var EditableContext$2 = React.createContext({});
// <tr {...props} />
var DragableRow = function (_a) {
    var form = _a.form, index = _a.index, props = __rest(_a, ["form", "index"]);
    return (React.createElement(EditableContext$2.Provider, { value: form },
        React.createElement(DragableBodyRow, __assign({}, props))));
};
var EditableRow$2 = function (_a) {
    var form = _a.form, index = _a.index, props = __rest(_a, ["form", "index"]);
    return (React.createElement(EditableContext$2.Provider, { value: form },
        React.createElement("tr", __assign({}, props))));
};
var EditableFormRow$2 = Form.create()(EditableRow$2);
var DragableFormRow = Form.create()(DragableRow);
var EditableCell$2 = /** @class */ (function (_super) {
    __extends(EditableCell, _super);
    function EditableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editing: false,
        };
        _this.toggleEdit = function () {
            var editing = !_this.state.editing;
            _this.setState({ editing: editing }, function () {
                if (editing) {
                    _this.input.focus();
                }
            });
        };
        _this.save = function (e) {
            var _a = _this.props, record = _a.record, handleSave = _a.handleSave;
            _this.form.validateFields(function (error, values) {
                if (error && error[e.currentTarget.id]) {
                    return;
                }
                _this.toggleEdit();
                handleSave(__assign({}, record, values));
            });
        };
        return _this;
    }
    EditableCell.prototype.render = function () {
        var _this = this;
        var editing = this.state.editing;
        var _a = this.props, editable = _a.editable, dataIndex = _a.dataIndex, title = _a.title, record = _a.record, index = _a.index, handleSave = _a.handleSave, restProps = __rest(_a, ["editable", "dataIndex", "title", "record", "index", "handleSave"]);
        return (React.createElement("td", __assign({}, restProps), editable ? (React.createElement(EditableContext$2.Consumer, null, function (form) {
            _this.form = form;
            return (editing ? (React.createElement(FormItem$3, { style: { margin: 0 } }, form.getFieldDecorator(dataIndex, {
                rules: [{
                        required: true,
                        message: title + " is required.",
                    }],
                initialValue: record[dataIndex],
            })(React.createElement(Input, { ref: function (node) { return (_this.input = node); }, onPressEnter: _this.save, onBlur: _this.save })))) : (React.createElement("div", { className: "editable-cell-value-wrap", style: { paddingRight: 24 }, onClick: _this.toggleEdit }, restProps.children)));
        })) : restProps.children));
    };
    return EditableCell;
}(React.Component));

var TreeNode = AntTree.TreeNode;
/**
 * 动态列组件
 */
var DynamicColTable = /** @class */ (function (_super) {
    __extends(DynamicColTable, _super);
    function DynamicColTable(props) {
        var _this = _super.call(this, props) || this;
        _this.onTablePerference = function () {
            var userId = _this.props.userId;
            var obj = new Object();
            if (window.localStorage.getItem("userTablePerference") != undefined) {
                obj = JSON.parse(window.localStorage.getItem("userTablePerference") || "");
            }
            obj[userId || 'uid'] = {
                showcols: _this.checkedColKeys
            };
            window.localStorage.setItem("userTablePerference", JSON.stringify(obj));
            //window.localStorage.removeItem("userTablePerference")
        };
        _this.checkedColKeys = [];
        _this.allColsWithVisibleStatus = [];
        // 数据列选择
        _this.getTreeSelectCols = function (data) {
            var nodes = [];
            data.map(function (element, index) {
                if (!element.isFilterCol && !element.fixed && !element.hidden) {
                    nodes.push((React.createElement(TreeNode, { key: element.key, title: element.title })));
                }
            });
            return nodes;
        };
        _this.editPlainOptions = [];
        _this.editCheckedOptions = [];
        _this.isClickHandleSearch = false; //设置字段后在未保存的情况下点击空白区域字段重置
        _this.onFilterDropdownVisibleChange = function (visible, type) {
            if (visible && !_this.isClickHandleSearch) {
                _this.isClickHandleSearch = false;
            }
        };
        _this.onCheck = function (checkedKeys) {
            //debugger
            _this.allColsWithVisibleStatus.forEach(function (el, index) {
                if (!_this.isAlwaysShowCol(el)) {
                    el.isShow = false;
                    checkedKeys.forEach(function (checkedKey) {
                        // 是选中的
                        if (el.key === checkedKey) {
                            el.isShow = true;
                        }
                    });
                }
            });
            var showCols = _this.getShowCols(_this.allColsWithVisibleStatus);
            _this.setState({
                showcols: showCols
            });
            _this.checkedColKeys = [].concat(checkedKeys);
            _this.onTablePerference();
        };
        _this.onDrop = function (info) {
            var dropKey = info.node.props.eventKey;
            var dragKey = info.dragNode.props.eventKey;
            var dropPos = info.node.props.pos.split("-");
            var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
            if (dropPosition === 1 || dropPosition === -1) {
                var loop1_1 = function (data, key, callback) {
                    data.forEach(function (item, index, arr) {
                        if (item.key === key) {
                            return callback(item, index, arr);
                        }
                        if (item.children) {
                            return loop1_1(item.children, key, callback);
                        }
                    });
                };
                var data = _this.allColsWithVisibleStatus;
                var dragObj_1;
                loop1_1(data, dragKey, function (item, index, arr) {
                    arr.splice(index, 1);
                    dragObj_1 = item;
                });
                var ar_1;
                var i_1;
                loop1_1(data, dropKey, function (item, index, arr) {
                    ar_1 = arr;
                    i_1 = index;
                });
                if (dropPosition === -1) {
                    ar_1.splice(i_1, 0, dragObj_1);
                }
                else {
                    ar_1.splice(i_1 + 1, 0, dragObj_1);
                }
                _this.allColsWithVisibleStatus = [].concat(data);
                var datas_1 = new Array();
                // if (noAddColOne) {
                //     datas.push(showcolumns[0]);
                //     noAddColOne = false;
                // }
                data.forEach(function (r, index) {
                    _this.props.defcols.forEach(function (rs) {
                        if (r.key === rs.key) {
                            _this.checkedColKeys.forEach(function (ck) {
                                if (rs.key === ck) {
                                    datas_1.push(rs);
                                }
                            });
                        }
                    });
                });
                _this.setState({
                    showcols: data
                });
            }
        };
        _this.getedDataSource = function (datas, index, pagesize, cond) {
            setTimeout(function () {
                _this.setState({
                    datas: datas
                });
            });
        };
        _this.getColumnSearchProps = function (colDef) { return ({
            filterDropdown: function (_a) {
                var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                return (React.createElement("div", { style: { padding: 8 } },
                    React.createElement(Input$1, { ref: function (node) {
                            _this.searchInput = node;
                        }, placeholder: "\u67E5\u627E " + colDef.fieldName, value: selectedKeys[0], onChange: function (e) { return setSelectedKeys(e.target.value ? [e.target.value] : []); }, onPressEnter: function () { return _this.handleSearch(selectedKeys, confirm, colDef); }, style: { width: 168, marginBottom: 8, display: 'block' } }),
                    React.createElement(Button$1, { type: "primary", onClick: function () { return _this.handleSearch(selectedKeys, confirm, colDef); }, icon: "search", size: "small", style: { width: 80, marginRight: 8 } }, "\u67E5\u8BE2"),
                    React.createElement(Button$1, { onClick: function () { return _this.handleReset(clearFilters); }, size: "small", style: { width: 80 } }, "\u91CD\u7F6E")));
            },
            filterIcon: function (filtered) { return (React.createElement(Icon$1, { type: "search", style: { color: filtered ? '#1890ff' : undefined } })); },
            onFilter: function (value, record) {
                if (record[colDef.dataIndex]) {
                    return record[colDef.dataIndex].toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
                else {
                    return false;
                }
            },
            onFilterDropdownVisibleChange: function (visible) {
                if (visible) {
                    setTimeout(function () { return _this.searchInput.select(); });
                }
            },
            render: function (text) {
                return (_this.state.searchedColumn === colDef && text) ? (React.createElement(Highlighter, { highlightStyle: { backgroundColor: '#ffc069', padding: 0 }, searchWords: [_this.state.searchText], autoEscape: true, textToHighlight: text.toString() })) : (text);
            },
        }); };
        _this.handleSearch = function (selectedKeys, confirm, dataIndex) {
            confirm();
            _this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
            });
        };
        _this.handleReset = function (clearFilters) {
            clearFilters();
            _this.setState({ searchText: '' });
        };
        _this.setDefCols(props.defcols);
        if (_this.props.getDatas) {
            _this.props.getDatas(0, 1, {}, _this.getedDataSource);
        }
        _this.setColSelectList();
        _this.state = {
            showcols: _this.getShowCols(_this.props.defcols),
            datas: _this.props.dataSource ? _this.props.dataSource : [],
            searchText: '',
            searchedColumn: '',
        };
        return _this;
    }
    DynamicColTable.prototype.setColSelectList = function () {
        var _this = this;
        //debugger
        //window.localStorage.removeItem("userTablePerference")
        if (window.localStorage.getItem("userTablePerference") != undefined) {
            var userTablePerference = JSON.parse(window.localStorage.getItem("userTablePerference") || "");
            var uid = this.props.userId || "uid";
            if (userTablePerference[uid] == undefined) ;
            else if (userTablePerference[uid].showcols.length > 0) {
                this.checkedColKeys.push(userTablePerference[uid].showcols);
                this.props.defcols.forEach(function (element) { _this.allColsWithVisibleStatus.push(element); });
                this.onCheck(userTablePerference[uid].showcols);
                return;
            }
        }
        if (!this.allColsWithVisibleStatus || this.allColsWithVisibleStatus.length == 0) {
            this.props.defcols.forEach(function (element) {
                if (element.isShow === '1' && !element.isFilterCol && !element.fixed
                    && !element.hidden) {
                    _this.checkedColKeys.push(element.fieldCode);
                }
                _this.allColsWithVisibleStatus.push(element);
            });
            // $params.tableHead = plainOptionsList;
        }
    };
    DynamicColTable.prototype.setDefCols = function (cols) {
        var _this = this;
        cols.map(function (element) {
            Object.assign(element, {
                title: element.fieldName,
                dataIndex: element.fieldCode,
                key: element.fieldCode,
                ellipsis: true,
                align: 'center',
                width: element.hidden ? 0 : 120,
            }, _this.getColumnSearchProps(element), _this.getColFilterProps(element), element);
        });
    };
    DynamicColTable.prototype.getColFilterProps = function (element) {
        var _this = this;
        if (element.isFilterCol) {
            return {
                filterDropdown: function (_a) {
                    var confirm = _a.confirm, clearFilters = _a.clearFilters;
                    return (React.createElement("div", { style: {
                            padding: 8,
                            height: 400
                        } },
                        React.createElement(AntTree, { checkable: true, className: "draggable-tree", draggable: true, blockNode: true, selectable: false, onCheck: _this.onCheck, checkedKeys: _this.checkedColKeys, onDrop: _this.onDrop, style: {
                                height: 350,
                                overflow: "auto"
                            } }, _this.getTreeSelectCols(_this.allColsWithVisibleStatus))));
                },
                filterIcon: function (filtered) { return (React.createElement(Icon$1, { type: "setting", theme: "filled" })); },
                onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange
            };
        }
        else {
            return {};
        }
    };
    DynamicColTable.prototype.isAlwaysShowCol = function (col) {
        // hidden is a width 0 
        if (col.isFilterCol || col.fixed || col.hidden) {
            return true;
        }
        else {
            return false;
        }
    };
    DynamicColTable.prototype.getShowCols = function (cols) {
        //debugger
        var newCols = [];
        cols.forEach(function (el) {
            if (el.sortDirections !== undefined && el.sorter === undefined) {
                // 默认的sorter
                el.sorter = function (a, b, sortDirection) {
                    var valuea = a[this.fieldCode];
                    var valueb = b[this.fieldCode];
                    if (valuea !== undefined && valueb !== undefined) {
                        return valuea.localeCompare(valueb);
                    }
                    else if (valuea === undefined) {
                        return 1;
                    }
                    else if (valueb === undefined) {
                        return -1;
                    }
                };
            }
            var col = Object.assign({}, el);
            if (el.isShow && el.isShow !== '0') {
                newCols.push(col);
            }
        });
        return newCols;
    };
    DynamicColTable.prototype.render = function () {
        var props = Object.assign({
            columns: this.state.showcols,
            dataSource: this.state.datas,
            pagination: this.props.pagination,
            bordered: true,
            locale: { sortTitle: '排序', filterTitle: '筛选', filterConfirm: '确定', filterReset: '重置' },
            size: "middle",
            scroll: {
                // x: 'calc(700px + 50%)',
                x: 1200,
            },
            rowKey: 'id',
        }, this.props);
        return (React.createElement(AntTable$1, __assign({}, props)));
    };
    return DynamicColTable;
}(Component));
// export class DynamicColTabletsDemo extends Component {
//     getDataSource: getDataSource = (index, size, cond, callback) => {
//         callback(datas.data)
//     }
//     render() {
//         return (
//             <DynamicColTable size="small" defcols={datas.colum} getDatas={this.getDataSource} pagination={false}>
//             </DynamicColTable>
//         )
//     }
// }

/**
 * 动态表格列定义，兼容antd表格列定义所有参数
 */
var ColDef = /** @class */ (function (_super) {
    __extends(ColDef, _super);
    function ColDef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColDef.prototype.render = function () {
        return (React.createElement("div", null));
    };
    return ColDef;
}(Component));

export { AntDatetimePick, AntEditTable, AntEditTableForm, AntInput, AntTable, AntTextarea, AntWfDragForm, CommonScheme, DynamicColTable, DynamicDragForm, DynamicForm, DynamicFormDragBuilder, FormGroup, FormItem$2 as FormItem, FormScheme, ModalComponent, ModalService, RegistorClass, SetComponent, Type, UIComponents, UIComponentsMap, WrappedAntWfForm, WrappedDynamicDragForm, WrappedDynamicForm };
//# sourceMappingURL=index.es.js.map
